import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import CommonIcon from "../../helpers/icons";
import $ from "jquery";
import {
  getParticularUser,
  updateUser,
  deleteUser,
  addUser,
  LastLogin,
} from "../../../action/UsersApi";
import Actions from "../../../action/api";
import {
  Backdrop,
  CircularProgress,
  Divider,
  TextField,
  withStyles,
} from "@material-ui/core";
import { Switch } from "@mui/material";

import API from "../../helpers/endpointservice";
import ListViewTable from "../../custom/ListView";
import { FormLabel } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "react-bootstrap/Button";
import {
  ToastMessageSuccess,
  ToastMessageFailure,
} from "../../custom/CommonFunction";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CToast, CToastBody, CToastClose } from "@coreui/react";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import CustomListView from "../MUIDataTable/CustomListView";
import ClearIcon from "@mui/icons-material/Clear";
import Countries from "../../helpers/countries";
import { Avatar, Box } from "@mui/material";
// import parsePhoneNumber, { parsePhoneNumberFromString } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from "libphonenumber-js/max";

// import Backdrop from '@mui/material/Backdrop';

const useStyles = (theme) => ({
  root: {
    width: "60px",
    height: "28px",
    padding: "0px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "rgba(34, 110, 183, 1) !important",
        "&:after": {
          display: "block",
        },
        "&:before": {
          display: "none",
        },
      },
    },
  },
  thumb: {
    color: "white !important",
    width: "20px",
    height: "20px",
    margin: "1px",
    marginLeft: "4px",
    marginTop: "4px",
    "&.MuiSwitch-thumb": {
      color: "white !important",
      backgroundColor: "white !important",
    },
  },
  track: {
    borderRadius: "20px !important",
    backgroundColor: "#818181 !important",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white !important",
      fontSize: "8px",
      position: "absolute",
      top: "6px",
    },
    "&:after": {
      content: "'Active'",
      left: "4px",
      top: "8px",
      display: "none",
    },
    "&:before": {
      content: "'Inactive'",
      right: "3px",
      top: "8px",
    },
  },
  checked: {
    color: "rgba(34, 110, 183, 1) !important",
    transform: "translateX(30px) !important",
  },
});

class Users extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      columnHeaders: [
        { key: "email", label: "Email", width: "35%" },
        { key: "name", label: "Name", width: "20%" },
        { key: "lastLoginDate", label: "Last Login", width: "15%" },
        { key: "isActive", label: "Status", width: "10%" },
        { key: "applications", label: "Application", width: "20%" },
      ],
      isScroll: false,
      groupedColumn: null,
      filtered: {},
      groupedData: {},
      normalData: [],
      collapsedGroups: {},
      totalCount: 0,
      isloading: false,
      isusersLoading: false,
      phoneError: "",
      isLoader: false,
      filters: {
        limit: 21,
        offset: 0,
        sortBy: "name",
        sortByOrder: "asc",
        name: "",
        email: "",
        isActive: null,
        lastLoginDate: null,
        status: null,
      },
      isFilterApplied: false,
      filteredOptions: {
        limit: 21,
        offset: 0,
        sortBy: "name",
        sortByOrder: "asc",
        name: "",
        email: "",
        isActive: null,
        lastLoginDate: null,
        status: null,
      },
      primaryPhoneCode: "",
      choice: {
        name: "",
        email: "",
        lastLoginDate: null,
        isActive: null,
        status: null,
      },
      managerValue: null,
      backdrop: false,
      opendailog: false,
      editUserId: null,
      isMobile: false,
      isMobile600: false,
      isMobile380: false,
      height: window.innerHeight,
      show: false,
      sortBy: "displayname",
      notifyCheckList: [],
      userId: 0,
      idnumber: 0,
      managerForFilter: [],
      managerForFilter1: [],
      supervisorListDefault: [],
      userHeading: "",
      ApplicationRole: [],
      LastLogin: "",
      tableLoader: false,
      addeditUser: {
        displayName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        employeeCode: 0,
        previous_EF: 0,
        dateOfJoin: "",
        manager: [],
        supervisor: [],
        notification_types: [],
        status: true,
        actionBy: "admin",
      },
      pageSize: 0,
      countryData: [],
      pageIndex: 10,
      columnFilter: [],
      sortingFilters: [],
      primaryPhoneCode: "",
      addUser: {
        firstName: "",
        lastName: "",
        email: "",
        isActive: true,
        userRole: "User",
        phonenumber: "",
        managerEmail: "",
        managerId: "",
      },
      editUserData: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        isActive: null,
        userRole: "User",
        phonenumber: "",
        isAdmin: false,
        managerEmail: "",
        managerId: "",
      },
      viewUser: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
      ssoDetails: [],
      tenantUsers: [],
      ManagerUsers: [],
      tenantValue: null,
      view: false,
      editUser: false,
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      managerError: false,
      firstNameErrorMessage: "",
      lastNameErrorMessage: "",
      emailErrorMessage: "",
      actionId: null,
      isAdd: false,
      load: false,
      columns: [
        {
          accessorKey: "email",
          header: "Email",
          minSize: 250,
          maxSize: 250,
          Cell: ({ cell, row }) => {
            return (
              <span
                onClick={() => {
                  this.handleEditId(row.original.id, row.original.email);
                }}
                className="table-link"
              >
                {row.original.email}
              </span>
            );
          },
          muiFilterTextFieldProps: {
            sx: {
              height: "32px !important",
              "& .MuiInputBase-root": {
                height: "32px !important",
              },
              "& .MuiInputBase-input": {
                height: "32px !important",
                padding: "6px 10px !important",
                boxSizing: "border-box",
              },
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                height: "32px !important",
              },
            },
          },
        },
        {
          accessorKey: "name",
          header: "Name",
          muiFilterTextFieldProps: {
            sx: {
              height: "32px !important",
              "& .MuiInputBase-root": {
                height: "36px !important",
              },
              "& .MuiInputBase-input": {
                height: "32px !important",
                padding: "6px 10px !important",
                boxSizing: "border-box",
              },
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                height: "32px !important",
              },
            },
          },
        },
        {
          accessorKey: "lastLoginDate",
          header: "Last Login",
          filterVariant: "date",
          minSize: 150,
          maxSize: 150,
          placeholder: "DD MMM YYYY",

          muiFilterDatePickerProps: ({ column }) => ({
            onChange: (value, context) => {
              console.log(value);
              context.inputRef?.blur();
              column.setFilterValue(value ? value : null);
            },
            format: "dd MMM yyyy",
            enableAccessibleFieldDOMStructure: false,
            sx: {
              "& .MuiInputBase-root": {
                height: "32px !important",
                minHeight: "32px !important",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiIconButton-root": {
                margin: "0 !important",
              },
            },
            slotProps: {
              field: {
                inputProps: {
                  placeholder: "DD MMM YYYY",
                },
              },
              variant: "standard",
              textField: {
                sx: {
                  "& input::placeholder": {
                    opacity: 1, // ensures placeholder stays visible
                  },
                },
                onFocus: (e) => {
                  e.target.blur();
                  const parent = e.target.parentElement;
                  console.log(parent);

                  setTimeout(() => {
                    if (parent?.classList.contains("Mui-focused")) {
                      parent.classList.remove("Mui-focused");
                    }
                  }, 500);
                },

                sx: {
                  height: "32px !important",
                  minHeight: "32px !important",
                  "& .MuiInputBase-root": {
                    height: "32px !important",
                    minHeight: "32px !important",
                  },
                  "& .MuiInputBase-input": {
                    height: "32px !important",
                    lineHeight: "1.2 !important",
                    paddingTop: "8px !important",
                    paddingBottom: "8px !important",
                    paddingLeft: "10px !important",
                    paddingRight: "10px !important",
                    boxSizing: "border-box",
                  },
                },
              },
            },
          }),
        },
        {
          accessorKey: "isActive",
          header: "Status",
          minSize: 150,
          maxSize: 150,
          Cell: ({ cell, row }) => {
            return row.original.isActive === "Active" ? (
              <span style={{ color: "green" }}>Active</span>
            ) : row.original.isActive === "Pending" ? (
              <span style={{ color: "orange" }}>Pending</span>
            ) : (
              <span style={{ color: "red" }}>Inactive</span>
            );
          },
          filterVariant: "select",
          muiFilterTextFieldProps: {
            sx: {
              "& .MuiInputBase-root": {
                position: "relative",
                paddingRight: "0px !important",
              },
              "& .MuiSelect-select.MuiInputBase-input": {
                paddingRight: "40px !important",
              },
              "& .MuiSelect-icon": {
                position: "absolute",
                right: "0px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              },
              "& .MuiInputAdornment-root": {
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 3,
                padding: 0,
                margin: 0,
              },
              "& .MuiSelect-select": {
                width: "100% !important",
              },
            },
          },
          filterSelectOptions: [
            { label: "Active", value: "Active" },
            { label: "Inactive", value: "Inactive" },
            { label: "Pending", value: "Pending" },
          ],
          muiFilterTextFieldProps: {
            select: true,
            sx: {
              "& .MuiSelect-select": {
                display: "flex !important",
                alignItems: "center !important",
                paddingTop: "6px !important",
                paddingBottom: "6px !important",
              },
              "& .MuiSelect-icon": {
                alignSelf: "center !important",
                marginTop: "0px !important",
              },
              "& .MuiInputBase-root": {
                display: "flex !important",
                alignItems: "center !important",
                height: "32px !important",
                padding: "6px 10px !important",
                boxSizing: "border-box",
              },
            },
          },
        },
        {
          minSize: 100,
          maxSize: 100,
          enableColumnActions: false,
          enableSorting: false,
          enableColumnFilter: false,
          muiTableHeadCellProps: {
            sx: {
              borderTop: "1px solid rgba(224, 224, 224, 1)",
              "& .Mui-TableHeadCell-Content-Labels": {
                paddingLeft: "0px",
                fontWeight: "400",
              },
            },
          },
          accessorKey: "applications",
          header: "Application",
          Cell: ({ cell, row }) => {
            return <span>-</span>;
          },
        },
      ],
    };
    this.tableRef = React.createRef();
    this.scrollContainerRef = React.createRef();
    this.scrollTimeout = null;
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };

  handleDataFetch = (pageSize, pageIndex, columnsFilters, sorting) => {
    this.setState({
      pageSize: pageSize,
      pageIndex: pageIndex,
      columnsFilters: columnsFilters,
      sortingFilters: sorting,
    });

    const filterObject = columnsFilters.reduce((acc, curr) => {
      acc[curr.id] = curr.value;
      return acc;
    }, {});
    let sortorder = !sorting[0]?.desc;
    let data = {
      sortBy: sorting[0]?.id,
      sortByOrder: sortorder ? "asc" : "desc",
      isActive: null,
      limit: pageIndex,
      offset: pageSize * pageIndex,
      status: filterObject.isActive ?? null,
      name: filterObject.name ?? "",
      email: filterObject.email ?? "",
      lastLoginDate: filterObject.lastLoginDate
        ? moment(filterObject.lastLoginDate).format("YYYY-MM-DD")
        : null,
    };
    this.getAllData(data, true);
  };

  getCountries = () => {
    Actions.GET(API.GET_COUNTRIES)
      .then((res) => {
        if (res.data) {
          const filteredData = res.data
            .filter(
              (item) => item.countryCode && item.countryCode.trim() !== ""
            )
            .map((item) => ({
              ...item,
              // optionally do more transformation here
            }));
          this.setState({ countryData: filteredData }, () => {
            console.log(this.state.countryData);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getMicrosoftUsers = async () => {
    try {
      this.setState({ isusersLoading: true });
      const res = await Actions.GET(API.GetMicrosoftUsers);
      if (res?.data) {
        this.setState({ tenantUsers: res.data });
        this.setState({ isusersLoading: false });
        return res.data;
      }
      this.setState({ isusersLoading: false });
      return null;
    } catch (error) {
      console.error("Error fetching Microsoft users:", error);
      this.setState({ isusersLoading: false });
      return null;
    }
  };

  getGoogleUsers = async () => {
    try {
      this.setState({ isusersLoading: true });
      const res = await Actions.GET(API.GetGoogleUsers);
      if (res?.data) {
        this.setState({ tenantUsers: res.data });
        this.setState({ isusersLoading: false });
        return res.data;
      }
      this.setState({ isusersLoading: false });
      return null;
    } catch (error) {
      console.error("Error fetching Google users:", error);
      this.setState({ isusersLoading: false });
      return null;
    }
  };

  getSSO = () => {
    this.setState({ isloading: true });
    Actions.GET(`${API.GET_SSO_DETAILS}`)
      .then((res) => {
        this.setState({ isloading: false });
        if (res.data !== undefined) {
          // this.setState({
          //   ssoDetails: [
          //     {
          //       clientId: "cc395268-f32c-4ffa-a77f-f751c4e74b48",
          //       clientSecret: "x2M8Q~1nPtBJSSzZTBd6YgOQb7ziWKCOoPd.TbvQ",
          //       providerType: "microsoft",
          //       microsoftTenantId: "9b995efe-255d-496c-b7bf-efc3ae8d8192",
          //       internalId: "28dac91d-d5b7-462f-a33c-3e1ef3ba30b0",
          //       isActive: false,
          //       identityProviderId: "6e7d6339-6387-4106-87bb-ae788343f36c",
          //       isChangedFromPreviousProvider: false,
          //     },
          //   ],
          // });
          this.callusersList(res.data);
          this.setState({ ssoDetails: res.data });
        } else {
          this.setState({
            ssoDetails: [],
          });
        }
      })
      .catch((error) => {
        this.setState({ isloading: false });
        console.log("error", error);
      });
  };

  callusersList = (ssoDetails) => {
    if (ssoDetails && ssoDetails.length > 0) {
      if (ssoDetails[0].providerType == "microsoft") {
        this.getMicrosoftUsers();
      } else if (ssoDetails[0].providerType == "google") {
        this.getGoogleUsers();
      }
    }
  };

  componentDidMount = async () => {
    // this.getCountries();
    this.setState({ countryData: Countries });
    this.getSSO();
    let data = {
      sortBy: this.state.filters.sortBy,
      sortByOrder: this.state.filters.sortByOrder,
      isActive: null,
      limit: this.state.filters.limit,
      offset: this.state.filters.offset,
      status: this.state.filters.status,
    };
    this.setState({
      filtered: data,
    });
    let tableLoader = false;
    if (this.state.isWebMobile) {
      await this.getAllData(data, tableLoader);
    }

    let userName = localStorage.getItem("userNameTAC");
    let values = await Actions.logoutRedirect(
      `${API.GET_LOGOUT}?email=${userName}`
    );
    localStorage.setItem("redirectURLTAC", values.data);

    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.addEventListener(
        "scroll",
        this.handleScrollss
      );
    }
  };
  handleScrollss = () => {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      const container = this.scrollContainerRef.current;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 150
      ) {
        this.handleScroll();
      }
    }, 200);
  };

  // componentWillUnmount() {
  //   // Clean up event listeners and intervals
  //   if (this.scrollContainerRef.current) {
  //     this.scrollContainerRef.current.removeEventListener('scroll', this.handleScrollss);
  //   }
  //   clearInterval(this.resizeInterval);
  // }

  // static getDerivedStateFromProps(nextProps, prevState) {

  //   const newUser = nextProps.getParticularUser;

  //   if (nextProps.getParticularUser) {

  //     console.log(nextProps.getParticularUser);
  //     const updatedState = {
  //       view: true,
  //       viewUser: nextProps.getParticularUser,
  //       isloading: false,
  //       editUserId: nextProps.getParticularUser.guid,
  //       editUserData: {
  //         id: nextProps.getParticularUser.id,
  //         firstName: nextProps.getParticularUser.firstName,
  //         lastName: nextProps.getParticularUser.lastName,
  //         email: nextProps.getParticularUser.email,
  //         isActive: nextProps.getParticularUser.isActive,
  //         phonenumber: nextProps.getParticularUser.phoneNumber,
  //         userRole: 'User',

  //       }

  //     };

  //     // nextProps.dispatch({ type: "USER_LOADED_SUCCESS", data: null });

  //     return updatedState;

  //   }

  //   return null;
  // }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const newUser = nextProps.getParticularUser;

  //   if (
  //     newUser &&
  //     (!prevState.viewUser || prevState.viewUser.id !== newUser.id)
  //   ) {
  //     return {
  //       view: true,
  //       viewUser: newUser,
  //       isloading: false,
  //       editUserId: newUser.guid,
  //       editUserData: {
  //         id: newUser.id,
  //         firstName: newUser.firstName,
  //         lastName: newUser.lastName,
  //         email: newUser.email,
  //         isActive: newUser.isActive,
  //         phonenumber: newUser.phoneNumber,
  //         userRole: 'User',
  //       },
  //     };
  //   }

  //   return null;
  // }

  getAllData = (data, tableLoader, resetTableOrder = false) => {
    // console.log(this.formatDate(data?.lastLoginDate),'getalldata');
    return new Promise((resolve, reject) => {
      tableLoader
        ? this.setState({ isLoader: true })
        : this.setState({ isloading: true });
      this.setState({ tableLoader: true });
      Actions.POST(`${API.GET_USERS_LIST}`, data)
        .then((res) => {
          if (res.data) {
            this.setState({ normalData: [] }, () => {
              this.processData(res.data, tableLoader, resetTableOrder);
            });

            this.setState({ isloading: false, isLoader: false });
            this.setState({ tableLoader: false });
            resolve(res.data);
          } else {
            this.setState({ tableLoader: false });
            this.setState({ isloading: false, isLoader: false });
            reject(new Error("No data in response")); // Reject the promise if there is no data
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ tableLoader: false });
          this.setState({ isloading: false, isLoader: false });
        });
    });
  };

  processData = (result, tableLoader, resetTableOrder) => {
    // ;
    const normalData = !resetTableOrder
      ? JSON.parse(JSON.stringify(this.state.normalData)) || []
      : [];
    const newData = [];
    // console.log(result);
    console.log(result);

    if (Array.isArray(result.items)) {
      result.items.forEach((value) => {
        const userData = {
          ...value,
          name: `${value.firstName} ${value.lastName}`,
          lastLoginDate: value.lastLoginDate
            ? moment(value.lastLoginDate).format("DD MMM YYYY")
            : "-",
          isActive: value.userStatus,
        };

        if (!normalData.some((x) => x.id === userData.id)) {
          normalData.push(userData);
        }
        newData.push(userData);
      });
    }

    const isValue = newData.length >= 10 ? false : true;

    this.setState({
      normalData: normalData,
      isLoader: false,
      isloading: false,
      isScroll: isValue,
      totalCount: result.totalCount,
    });
  };

  EditFormShow = () => {
    this.setState({ isEditFormShow: true }, () => {
      let myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("editform")
      );
      myOffcanvas.show();
      $("body").addClass("scrollhide");
      $(".main-content").addClass("scrollhide");
    });
  };

  viewuser = (event) => {
    const userId = event.target.id;
    this.setState({
      view: true,
      editUser: true,
    });
    this.setState({ actionId: userId }, () => {
      this.props.dispatch(getParticularUser(userId));

      this.newFormShow(false);
    });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };

  clearFilter = () => {
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          name: "",
          email: "",
          isActive: null,
          lastLoginDate: null,
          status: null,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          name: "",
          email: "",
          isActive: null,
          lastLoginDate: null,
          status: null,
        },
        isFilterApplied: false,
        choice: {
          ...prevState.choice,
          name: "",
          email: "",
          isActive: null,
          lastLoginDate: null,
          status: null,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: {
          sortBy: prevState.filters.sortBy.toLowerCase(),
          sortByOrder: prevState.filters.sortByOrder,
          limit: 15,
          offset: 0,
          name: "",
          email: "",
          isActive: null,
          lastLoginDate: null,
        },
      }),
      () => {
        const data = {
          sortBy: this.state.filters.sortBy.toLowerCase(),
          sortByOrder: this.state.filters.sortByOrder,
          limit: 15,
          offset: 0,
          name: this.state.filters.name,
          email: this.state.filters.email,
          isActive: null,
          lastLoginDate: this.state.filters.lastLoginDate,
          status: this.state.filters.status,
        };

        this.getAllData(data, true);
        this.closeWebFilter();
      }
    );
  };

  toggleWebFilter = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("FilterScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
  };

  closeWebFilter = () => {
    $("#FilterScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    this.setState({ rows: [] });
    this.setState({});
  };

  newFormShow = async (isNew, email = null) => {
    this.getManagerUsers(email);
    this.setState({ phoneError: "", tenantValue: null });
    let myOffcanvas;
    if (isNew) {
      if (this.state.ssoDetails && this.state.ssoDetails.length > 0) {
        if (this.state.ssoDetails[0].providerType == "microsoft") {
          // let data = await this.getMicrosoftUsers();
          myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("AddFormuser")
          );
        } else if (this.state.ssoDetails[0].providerType == "google") {
          // let data = await this.getGoogleUsers();
          myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("AddFormuser")
          );
        } else {
          myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("AddFormuser")
          );
        }
      } else {
        myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById("AddFormuser")
        );
      }
    } else {
      myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("AddFormuser")
      );
    }

    myOffcanvas.show();
    $("body").addClass("scrollhide");
    $(".main-content").addClass("scrollhide");
    this.setState({
      backdrop: true,
      view: true,
    });
  };

  getManagerUsers = (email = null) => {
    let data = {};
    if (email) {
      data = {
        email: email,
      };
    }
    Actions.POST(API.GET_USERS_LIST_WOPAGE, data)
      .then((res) => {
        if (res.data) {
          this.setState({ ManagerUsers: res.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addEditChange = (e, selectedValue, title) => {
    // Handle the case when title is provided
    if (title) {
      // Check if we are in edit mode
      if (this.state.editUser) {
        if (title === "isActive") {
          this.setState(
            {
              editUserData: {
                ...this.state.editUserData,
                isActive: e.target.checked,
              },
            },
            () => {
              console.log(this.state.editUserData);
            }
          );
        } else if (title === "phonenumber") {
          // Restrict input to numeric values only
          const numericValue = e.target.value.replace(/[^0-9]/g, "");
          this.setState({
            editUserData: {
              ...this.state.editUserData,
              [title]: numericValue,
            },
          });
        } else {
          this.setState({
            editUserData: {
              ...this.state.editUserData,
              [title]: e.target.value,
            },
          });
        }
      } else {
        if (title === "isActive") {
          this.setState({
            addUser: {
              ...this.state.addUser,
              isActive: e.target.checked,
            },
          });
        } else if (title === "phonenumber") {
          // Restrict input to numeric values only
          const numericValue = e.target.value.replace(/[^0-9]/g, "");
          this.setState({
            addUser: {
              ...this.state.addUser,
              [title]: numericValue,
            },
          });
        } else {
          this.setState({
            addUser: {
              ...this.state.addUser,
              [title]: e.target.value,
            },
          });
        }
      }
    }
  };

  parseUnknownPhone(rawPhone) {
    if (!rawPhone)
      return { country: null, countryCode: null, phoneNumber: null };

    // clean spaces, dashes, parentheses
    const cleaned = rawPhone.toString().trim();

    // try to parse as international number
    const parsed = parsePhoneNumberFromString(cleaned);

    if (parsed) {
      return {
        country: parsed.country || null, // e.g. 'IN'
        countryCode: "+" + parsed.countryCallingCode, // e.g. '+91'
        phoneNumber: parsed.nationalNumber, // e.g. '9003077356'
        isValid: parsed.isValid(), // boolean
        original: rawPhone,
      };
    }

    // fallback — no '+' prefix or can't be parsed
    return {
      country: null,
      countryCode: null,
      phoneNumber: cleaned.replace(/\D/g, ""), // digits only
      isValid: false,
      original: rawPhone,
    };
  }

  handletenantChange = (event, value) => {
    console.log(value);
    this.setState({ tenantValue: value });

    const phone = "+9003077356";
    const parsed = this.parseUnknownPhone(value?.mobilePhone ?? "");

    this.setState({
      addUser: {
        ...this.state.addUser,
        firstName: value?.givenName ?? "",
        lastName: value?.surname ?? "",
        email: value?.email ?? "",
        phonenumber: parsed?.phoneNumber ?? "",
      },
      primaryPhoneCode: parsed?.countryCode ? parsed?.countryCode : "",
    });
  };
  handleManagerChangeAdd = (event, value) => {
    console.log(value);
    this.setState({ managerValue: value });

    this.setState({
      addUser: {
        ...this.state.addUser,
        managerEmail: value?.email ?? "",
        managerId: value?.id ?? "",
      },
    });
  };
  handleManagerChangeEdit = (event, value) => {
    console.log(value);
    this.setState({ managerValue: value });

    this.setState({
      editUserData: {
        ...this.state.editUserData,
        managerEmail: value?.email ?? "",
        managerId: value?.id ?? "",
      },
    });
  };

  lookupChange = (e, selectedValue, title) => {
    if (title === "name") {
      this.setState({ choice: { ...this.state.choice, name: e.target.value } });
    }

    if (title === "email") {
      this.setState({
        choice: { ...this.state.choice, email: e.target.value },
      });
    }

    if (title === "isActive") {
      if (selectedValue !== null) {
        this.setState({
          choice: {
            ...this.state.choice,
            status: selectedValue.status ?? null,
          },
        });
      } else {
        this.setState({ choice: { ...this.state.choice, status: null } });
      }
    }

    if (title === "lastLoginDate") {
      const formattedDate = e.target.value;
      console.log(formattedDate);
      this.setState({
        choice: { ...this.state.choice, lastLoginDate: e.target.value },
      });
    }
  };

  handleAdd = () => {
    if (this.handleValidation()) {
      this.submitUserAdd("add");
    } else {
      this.setState({ isloading: false });
    }
  };

  handleValidation = () => {
    const { addUser } = this.state;
    let pass = true;

    if (!addUser.email) {
      this.setState({
        emailError: true,
        emailErrorMessage: "Please fill the email",
      });
      pass = false;
    } else {
      this.setState({
        emailError: false,
        emailErrorMessage: "",
      });
    }
    if (!addUser.managerId.trim()) {
      this.setState({
        managerError: true,
      });
      pass = false;
    } else {
      this.setState({
        managerError: false,
      });
    }

    if (
      (this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null) ||
      addUser.phonenumber !== ""
    ) {
      if (
        ((this.state.primaryPhoneCode !== "" ||
          this.state.primaryPhoneCode !== null) &&
          addUser.phonenumber == "") ||
        ((this.state.primaryPhoneCode == "" ||
          this.state.primaryPhoneCode == null) &&
          addUser.phonenumber !== "")
      ) {
        if (
          this.state.primaryPhoneCode !== "" &&
          this.state.primaryPhoneCode !== null &&
          addUser.phonenumber == ""
        ) {
          pass = false;
          this.setState({ phoneError: "Phone number is missing" });
        } else if (
          (this.state.primaryPhoneCode == "" ||
            this.state.primaryPhoneCode == null) &&
          addUser.phonenumber !== ""
        ) {
          pass = false;
          this.setState({ phoneError: "Country code is missing" });
        }
      } else {
        this.setState({ phoneError: "Country code is missing" });
      }

      if (
        this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null &&
        addUser.phonenumber !== ""
      ) {
        let bool = this.validatePhoneNumberByDialCode(
          this.state.primaryPhoneCode,
          addUser.phonenumber
        );
        if (!bool) {
          pass = false;
          this.setState({ phoneError: "Invalid phone number" });
          // this.state.errorPhoneNo = true;
          // if (!focusErrorField) {
          //     focusErrorField = this.phNoRef.current;
          // }
        } else {
          this.setState({ phoneError: "" });
        }
      }
    } else {
      this.setState({ phoneError: "" });
    }

    return pass;
  };

  validatePhoneNumberByDialCode = (countryCode, phoneNumber) => {
    try {
      const fullNumber = `${countryCode}${phoneNumber}`;
      const phone = parsePhoneNumberFromString(fullNumber);
      return phone && phone.isValid();
    } catch (error) {
      console.error("Validation failed:", error.message);
      return false;
    }
  };

  showToastMessage = () => {
    this.customToast("User Invited Successfully !");
  };
  showToastfail = () => {
    this.customToast("User Invite Failed, Email Already Exist");
  };
  showToastupdateMessage = () => {
    this.customToast("Updated Successfully !");
  };
  showToastDeleteMessage = () => {
    this.customToast("User Deleted Successfully !");
  };
  showToastfailupdateMessage = () => {
    this.customToast("Update Failed !");
  };
  submitUser = (type) => {
    const { email } =
      type === "add" ? this.state.addUser : this.state.editUserData;

    this.validateEmail(email)
      .then(({ isValid }) => {
        if (isValid) {
          this.setState({ isloading: true });
          return new Promise((resolve, reject) => {
            if (type === "add") {
              resolve(this.props.dispatch(addUser(this.state.addUser)));
            } else {
              let edit = {
                ...this.state.editUserData,
                phonenumber: this.state.editUserData.phonenumber
                  ? this.state.primaryPhoneCode +
                    "-" +
                    this.state.editUserData.phonenumber
                  : "",
              };
              resolve(
                this.props
                  .dispatch(updateUser(edit, this.state.actionId))
                  .then((res) => {
                    this.showToastupdateMessage();
                  })
              );
            }
          });
        }
      })
      .then((result) => {
        return new Promise((resolve, reject) => {
          let data = {
            sortBy: this.state.filters.sortBy,
            sortByOrder: this.state.filters.sortByOrder,
            isActive: null,
            limit: this.state.filters.limit,
            offset: this.state.filters.offset,
            status: this.state.filters.status,
          };
          this.setState({
            filtered: data,
          });
          let tableLoader = false;
          if (this.state.isWebMobile) {
            resolve(
              !this.state.emailError
                ? (this.setState({ isloading: true }),
                  this.getAllData(data, tableLoader, true))
                : ""
            );
          } else {
            resolve(
              !this.state.emailError
                ? (this.setState({ isloading: true }),
                  this.handleDataFetch(
                    this.state.pageSize,
                    this.state.pageIndex,
                    this.state.columnFilter,
                    this.state.sortingFilters
                  ))
                : ""
            );
          }
          reject(this.showToastfail);
        });
      })
      .then((result) => {
        this.validateEmail(email).then(({ isValid }) => {
          if (isValid) {
            return new Promise((resolve, reject) => {
              resolve(
                this.closeForm(),
                this.setState({ isloading: false, isLoader: false })
              );
            });
          }
        });
      })
      .catch((error) => {
        console.error("Submit user error:", error);
        this.showToastfail();
        this.setState({ isloading: false, isLoader: false });
      });
  };
  submitUserAdd = (type) => {
    const { email } =
      type === "add" ? this.state.addUser : this.state.editUserData;

    this.validateEmail1(email)
      .then(({ isValid, reason }) => {
        if (isValid) {
          this.setState({ isloading: true });
          return new Promise((resolve, reject) => {
            if (type === "add") {
              let add = {
                ...this.state.addUser,
                phonenumber: this.state.addUser.phonenumber
                  ? this.state.primaryPhoneCode +
                    "-" +
                    this.state.addUser.phonenumber
                  : "",
              };
              resolve(this.props.dispatch(addUser(add)));
            } else {
              let edit = {
                ...this.state.editUserData,
                phonenumber: this.state.editUserData.phonenumber
                  ? this.state.primaryPhoneCode +
                    "-" +
                    this.state.editUserData.phonenumber
                  : "",
              };
              resolve(
                this.props
                  .dispatch(updateUser(edit, this.state.actionId))
                  .then((res) => {
                    this.showToastupdateMessage();
                  })
              );
            }
          });
        } else {
          this.setState({ isloading: false });
          return Promise.reject(reason);
        }
      })
      .then((result) => {
        return new Promise((resolve, reject) => {
          let data = {
            sortBy: this.state.filters.sortBy,
            sortByOrder: this.state.filters.sortByOrder,
            isActive: null,
            limit: this.state.filters.limit,
            offset: this.state.filters.offset,
            status: this.state.filters.status,
          };
          this.setState({
            filtered: data,
          });
          let tableLoader = false;
          this.callusersList(this.state.ssoDetails);
          if (this.state.isWebMobile) {
            resolve(
              !this.state.emailError
                ? (this.setState({ isloading: true }),
                  this.getAllData(data, tableLoader, true))
                : ""
            );
          } else {
            resolve(
              !this.state.emailError
                ? (this.setState({ isloading: true }),
                  this.handleDataFetch(
                    this.state.pageSize,
                    this.state.pageIndex,
                    this.state.columnFilter,
                    this.state.sortingFilters
                  ))
                : ""
            );
          }

          reject(this.showToastfail);
        });
      })
      .then((result) => {
        this.validateEmail(email).then(({ isValid }) => {
          if (isValid) {
            return new Promise((resolve, reject) => {
              resolve(
                this.closeForm(),
                this.setState({ isloading: false, isLoader: false })
              );
            });
          } else {
            this.setState({ isloading: false });
          }
        });
      })
      .catch((error) => {
        console.error("Submit user error:", error);
        if (error !== "regex") {
          this.showToastfail();
        }
        this.setState({ isloading: false, isLoader: false });
      });
  };
  componentDidUpdate = () => {
    if (this.props.addUser == 200) {
      this.showToastMessage();
      this.props.dispatch({ type: "USER_ADDED_SUCCESS", data: 400 });
    }
    if (this.scrollContainerRef.current) {
    }
  };

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check email format
    if (!emailRegex.test(String(email).toLowerCase())) {
      this.setState({
        emailError: true,
        emailErrorMessage: "Invalid email",
      });
      return Promise.resolve({ isValid: false, reason: "regex" });
    } else {
      this.setState({ isloading: true });
    }

    const emailUrl = `${API.EMAIL_VERIFY}/${email}/Verify`;
    const headers = Actions.getToken();

    return axios
      .get(emailUrl, { headers })
      .then((response) => {
        if (response.data) {
          return { isValid: true, reason: "passed" };
        } else {
          this.setState({
            emailError: true,
            emailErrorMessage: "Email is already in use",
          });
          return { isVaid: false, reason: "error" };
        }
      })
      .catch((error) => {
        console.error("Email validation error:", error);
        this.setState({
          emailError: true,
          emailErrorMessage: "Error validating email",
        });
        throw error;
      });
  };
  validateEmail1 = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check email format
    if (!emailRegex.test(String(email).toLowerCase())) {
      this.setState({
        emailError: true,
        emailErrorMessage: "Invalid email",
      });
      return Promise.resolve({ isValid: false, reason: "regex" });
    } else {
      this.setState({ isloading: true });
    }

    const emailUrl = `${API.EMAIL_VERIFY}/${email}/Verify`;
    const headers = Actions.getToken();

    return axios
      .get(emailUrl, { headers })
      .then((response) => {
        if (!response.data) {
          return { isValid: true, reason: "passed" };
        } else {
          this.setState({
            emailError: true,
            emailErrorMessage: "Email is already in use",
          });
          return { isValid: false, reason: "error" };
        }
      })
      .catch((error) => {
        console.error("Email validation error:", error);
        this.setState({
          emailError: true,
          emailErrorMessage: "Error validating email",
        });
        throw error;
      });
  };

  handleUpdate = () => {
    this.setState({ isloading: true });
    if (this.handleEditValidation()) {
      this.submitUser("updated");
    } else {
      this.setState({ isloading: false });
    }
  };

  handleEditValidation = () => {
    const { editUserData } = this.state;
    let pass = true;

    if (!editUserData.email) {
      this.setState({
        emailError: true,
        emailErrorMessage: "Please fill the email",
      });
      pass = false;
    } else {
      this.setState({
        emailError: false,
        emailErrorMessage: "",
      });
    }
    if (!editUserData.managerId.trim()) {
      this.setState({
        managerError: true,
      });
      pass = false;
    } else {
      this.setState({
        managerError: false,
      });
    }

    if (
      (this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null) ||
      editUserData.phonenumber !== ""
    ) {
      if (
        ((this.state.primaryPhoneCode !== "" ||
          this.state.primaryPhoneCode !== null) &&
          editUserData.phonenumber == "") ||
        ((this.state.primaryPhoneCode == "" ||
          this.state.primaryPhoneCode == null) &&
          editUserData.phonenumber !== "")
      ) {
        if (
          this.state.primaryPhoneCode !== "" &&
          this.state.primaryPhoneCode !== null &&
          editUserData.phonenumber == ""
        ) {
          pass = false;
          this.setState({ phoneError: "Phone number is missing" });
        } else if (
          (this.state.primaryPhoneCode == "" ||
            this.state.primaryPhoneCode == null) &&
          editUserData.phonenumber !== ""
        ) {
          pass = false;
          this.setState({ phoneError: "Country code is missing" });
        }
      } else {
        this.setState({ phoneError: "Country code is missing" });
      }

      if (
        this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null &&
        editUserData.phonenumber !== ""
      ) {
        let bool = this.validatePhoneNumberByDialCode(
          this.state.primaryPhoneCode,
          editUserData.phonenumber
        );
        if (!bool) {
          pass = false;
          this.setState({ phoneError: "Invalid phone number" });
          // this.state.errorPhoneNo = true;
          // if (!focusErrorField) {
          //     focusErrorField = this.phNoRef.current;
          // }
        } else {
          this.setState({ phoneError: "" });
        }
      }
    } else {
      this.setState({ phoneError: "" });
    }

    return pass;
  };

  editUser = () => {
    this.setState({
      editUser: true,
      addUser: {},
      view: false,
    });
  };

  applyFilter = () => {
    const { choice, filters } = this.state;

    const lastLoginDate = choice.lastLoginDate
      ? new Date(choice.lastLoginDate).toISOString()
      : null;

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      name: choice.name,
      email: choice.email,
      isActive: null,
      status: choice.status,
      lastLoginDate: lastLoginDate,
    };

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          name: choice.name,
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          name: choice.name,
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        if (
          (choice.name != null && choice.name.trim() !== "") ||
          (choice.email != null && choice.email.trim() !== "") ||
          choice.lastLoginDate ||
          choice.status
        ) {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }

        this.getAllData(data);
        this.closeWebFilter();
      }
    );
  };
  applyFilterName = () => {
    const { choice, filters } = this.state;

    const lastLoginDate = choice.lastLoginDate
      ? new Date(choice.lastLoginDate).toISOString()
      : null;

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      name: "",
      email: choice.email,
      isActive: null,
      status: choice.status,
      lastLoginDate: lastLoginDate,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          name: "",
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        choice: {
          ...prevState.choice,
          name: "",
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          name: "",
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        if (
          (choice.email != null && choice.email.trim() !== "") ||
          choice.lastLoginDate ||
          choice.status
        ) {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }

        this.getAllData(data);
        this.closeWebFilter();
      }
    );
  };
  applyFilterStatus = () => {
    const { choice, filters } = this.state;
    console.log(choice);

    const lastLoginDate = choice.lastLoginDate
      ? new Date(choice.lastLoginDate).toISOString()
      : null;
    console.log(lastLoginDate);

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      name: choice.name,
      email: choice.email,
      isActive: null,
      status: null,
      lastLoginDate: lastLoginDate,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          name: choice.name,
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: null,
        },
        choice: {
          ...prevState.choice,
          status: null,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          name: choice.name,
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: null,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        if (
          (choice.name != null && choice.name.trim() !== "") ||
          (choice.email != null && choice.email.trim() !== "") ||
          choice.lastLoginDate
        ) {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }

        this.getAllData(data);
        this.closeWebFilter();
      }
    );
  };
  applyFilterlogin = () => {
    const { choice, filters } = this.state;
    console.log(choice);

    const lastLoginDate = choice.lastLoginDate
      ? new Date(choice.lastLoginDate).toISOString()
      : null;
    console.log(lastLoginDate);

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      name: choice.name,
      email: choice.email,
      isActive: null,
      status: choice.status,
      lastLoginDate: null,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          name: choice.name,
          email: choice.email,
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        choice: {
          ...prevState.choice,
          lastLoginDate: null,
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          name: choice.name,
          email: choice.email,
          isActive: null,
          lastLoginDate: null,
          status: choice.status,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        if (
          (choice.name != null && choice.name.trim() !== "") ||
          (choice.email != null && choice.email.trim() !== "") ||
          choice.status
        ) {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }

        this.getAllData(data);
        this.closeWebFilter();
      }
    );
  };
  applyFilterEmail = () => {
    const { choice, filters } = this.state;
    console.log(choice);

    const lastLoginDate = choice.lastLoginDate
      ? new Date(choice.lastLoginDate).toISOString()
      : null;
    console.log(lastLoginDate);

    const data = {
      sortBy: filters.sortBy.toLowerCase(),
      sortByOrder: filters.sortByOrder,
      limit: 15,
      offset: 0,
      name: choice.name,
      email: "",
      isActive: null,
      status: choice.status,
      lastLoginDate: lastLoginDate,
    };
    console.log(data);

    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          name: choice.name,
          email: "",
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        choice: {
          ...prevState.choice,
          email: "",
        },
        filteredOptions: {
          ...prevState.filteredOptions,
          name: choice.name,
          email: "",
          isActive: null,
          lastLoginDate: choice.lastLoginDate,
          status: choice.status,
        },
        normalData: [],
        groupedData: {},
        groupedColumn: null,
        filtered: data,
        tableLoader: true,
      }),
      () => {
        if (
          (choice.name != null && choice.name.trim() !== "") ||
          choice.lastLoginDate ||
          choice.status
        ) {
          this.setState({ isFilterApplied: true });
        } else {
          this.setState({ isFilterApplied: false });
        }

        this.getAllData(data);
        this.closeWebFilter();
      }
    );
  };

  closeForm = () => {
    this.setState({ primaryPhoneCode: "" });
    $("#AddFormuser").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");

    $("body").removeClass("scrollhide");
    $(".main-content").removeClass("scrollhide");
    setTimeout(() => {
      this.setState({
        rows: [],
        viewuser: {},
        view: false,
        addUser: {
          firstName: "",
          lastName: "",
          email: "",
          isActive: true,
          userRole: "User",
          phonenumber: "",
          managerEmail: "",
          managerId: "",
        },
        editUserData: {
          id: "",
          firstName: "",
          lastName: "",
          email: "",
          isActive: null,
          userRole: "User",
          phonenumber: "",
          isAdmin: false,
          managerEmail: "",
          managerId: "",
        },

        backdrop: false,
        editUser: false,
        emailError: false,
        managerError: false,
        lastNameError: false,
        firstNameError: false,
      });
    }, 500);
  };

  //Scroll
  handleScroll = () => {
    if (!this.state.isScroll) {
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoader: true,
          filtered: {
            ...prevState.filtered,
            offset: prevState.filtered.offset + 10,
          },
        }),
        () => {
          let tableLoader = true;
          this.getAllData(this.state.filtered, tableLoader);
        }
      );
    }
  };

  handleEditId = (id, email) => {
    const userId = id;
    this.props.dispatch({ type: "USER_LOADED_SUCCESS", data: null });
    this.setState(
      {
        isloading: true,
        view: false,
        actionId: userId,
        editUser: true,
      },
      () => {
        this.props
          .dispatch(getParticularUser(userId))
          .then((res) => {
            const fullPhone = res.data.phoneNumber || "";
            this.setState({ phoneError: "", orgError: "" });
            let primaryPhoneCod = "";
            let primaryPhone = "";
            if (fullPhone.includes("-")) {
              [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
            } else if (fullPhone.startsWith("+")) {
              primaryPhoneCod = fullPhone;
            } else {
              primaryPhone = fullPhone;
            }
            this.setState({
              view: true,
              viewUser: res.data,
              isloading: false,
              editUserId: res.data.guid,
              editUserData: {
                id: res.data.id,
                firstName: res.data.firstName,
                lastName: res.data.lastName,
                email: res.data.email,
                isActive: res.data.isActive,
                phonenumber: primaryPhone,
                userRole: "User",
                isAdmin: res.data.isAdmin,
                managerEmail: res.data.managerEmail ?? "",
                managerId: res.data.managerId ?? "",
              },
              primaryPhoneCode: primaryPhoneCod,
            });
            this.setState({ isloading: false });
          })
          .catch((error) => {
            console.log(error);
            this.setState({ isloading: false });
          });
        this.newFormShow(false, email);
      }
    );
  };

  handleSort = (column) => {
    let { choice, filters } = this.state;
    let sortByOrder = "asc";

    if (filters.sortBy === column && filters.sortByOrder === "asc") {
      sortByOrder = "desc";
    }
    const lastLoginDate = choice.lastLoginDate
      ? new Date(choice.lastLoginDate).toISOString()
      : null;

    var data = {
      sortBy: column.toLowerCase(),
      sortByOrder: sortByOrder,
      offset: 0,
      limit: 15,
      status: this.state.filters.status,
      title: this.state.filters.title,
      clientId: this.state.filters.clientId,
      roleId: this.state.filters.roleId,
      openPositions: this.state.filters.openPositions,
      skillSetId: this.state.filters.skillSetId,
      priority: this.state.filters.priority,
      countryId: this.state.filters.countryId,
      name: choice.name,
      email: choice.email,
      isActive: null,
      status: choice.status,
      lastLoginDate: lastLoginDate,
    };
    this.state.groupedColumn = null;
    this.state.normalData = [];
    this.state.groupedData = {};
    this.state.filters.sortBy = column;
    this.state.filters.sortByOrder = sortByOrder;
    this.state.filtered = data;
    let tableLoader = true;
    //this.setState({}, () => { this.getAllData(data, tableLoader) })
    this.getAllData(data, tableLoader);
    // this.setState({ filters: { sortBy: column, sortByOrder } }, () => this.groupData());
  };
  popup = () => {
    this.state.opendailog = true;
  };
  noAction = () => {
    this.setState({ opendailog: false });
  };

  yesAction = () => {
    let data = [this.state.editUserData.id];
    this.validateEmail(this.state.editUserData.email)
      .then((isValid) => {
        if (isValid) {
          return new Promise((resolve, reject) => {
            resolve(this.props.dispatch(deleteUser(data)));
          });
        }
      })
      .then((result) => {
        return new Promise((resolve, reject) => {
          let data = {
            sortBy: this.state.filters.sortBy,
            sortByOrder: this.state.filters.sortByOrder,
            isActive: null,
            limit: this.state.filters.limit,
            offset: this.state.filters.offset,
            status: this.state.filters.status,
          };
          this.setState({
            filtered: data,
          });
          let tableLoader = false;
          this.callusersList(this.state.ssoDetails);
          if (this.state.isWebMobile) {
            resolve(
              !this.state.emailError
                ? (this.setState({ isloading: true }),
                  this.getAllData(data, tableLoader, true))
                : ""
            );
          } else {
            resolve(
              this.handleDataFetch(
                this.state.pageSize,
                this.state.pageIndex,
                this.state.columnFilter,
                this.state.sortingFilters
              ),
              this.closeForm(),
              this.showToastDeleteMessage()
            );
          }
          // resolve(this.getAllData(data, tableLoader, true), this.closeForm(), this.showToastDeleteMessage());
        });
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(this.state.editUserData.id);
    this.setState({ opendailog: false });
  };

  render() {
    // console.log();
    let { isWebMobile, isloading } = this.state;
    let { classes } = this.props;

    // console.log(this.state.groupedData,'-groupdata',this.state.normalData,'-newdata',this.state.groupedColumn);
    return !this.props.BG_LOADER ? (
      <>
        <ToastContainer />
        {$("#AddScreen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        {isWebMobile ? (
          <>
            <Backdrop
              className="spinner-backdrop"
              open={isloading || this.props.addUserIsLoader}
            >
              <CircularProgress color="primary" />
            </Backdrop>
            <div className="row">
              {/* <div className="col-12 titlebar-mob"> */}
              <div className="row">
                <div className="col-auto">
                  <span
                    className="mobile-menuusers"
                    onClick={() => this.props.toggleMenu()}
                  >
                    <CommonIcon fileName={"Menu"} />
                  </span>
                </div>
                <div className="col-5 ps-0">
                  <span className="headerform-mobile">Users</span>
                </div>
                {/* <div className='col-2 col-sm-2'>
                    <span className='mobile-more' onClick={() => this.toggleExtraFunc()}><CommonIcon fileName={'MoreIcon'} /></span>
                    {this.state.showSignOut && (
                      <div className="sign-out-container">
                        <button className='button' onClick={() => this.props.handleLogout()} color="primary">Sign Out</button>
                      </div>
                    )}
                  </div> */}
                <div className="col-5 mt-1 pe-1">
                  <div className="float-end d-flex align-items-stretch gap-1">
                    <button
                      className=" btn-fun btn-new fs-7 d-flex align-items-center"
                      type="button"
                      onClick={() => {
                        this.newFormShow(true);
                      }}
                    >
                      <CommonIcon fileName={"AddPlus1"} />
                      Invite
                    </button>{" "}
                    <button
                      style={{ paddingRight: "12px", paddingLeft: "12px" }}
                      className=" btn-fun d-flex align-items-center justify-content-center"
                      type="button"
                      onClick={this.toggleWebFilter}
                    >
                      <CommonIcon
                        fileName={
                          this.state.isFilterApplied ? "Filtered1" : "Filter1"
                        }
                      />{" "}
                    </button>{" "}
                  </div>
                </div>
                <span className="mt-15">
                  <Divider orientation="vertical" flexItem thickness={2} />
                </span>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-sm-6 justify-right pt-2"></div>
            </div>

            {this.state.isFilterApplied && (
              <>
                <div className="mt-3 mb-0" style={{ paddingRight: "2rem" }}>
                  {this.state.filteredOptions.name !== "" &&
                    this.state.choice.name !== null && (
                      <span className="filteredBadge">
                        <span>Name</span>
                        <span onClick={this.applyFilterName} className="ms-2">
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    )}
                  {this.state.filteredOptions.email !== "" &&
                    this.state.choice.email !== null && (
                      <span className="filteredBadge">
                        <span>Email</span>
                        <span onClick={this.applyFilterEmail} className="ms-2">
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    )}
                  {this.state.filteredOptions.lastLoginDate !== "" &&
                    this.state.choice.lastLoginDate !== null && (
                      <span className="filteredBadge">
                        <span>Last Login</span>
                        <span onClick={this.applyFilterlogin} className="ms-2">
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    )}
                  {this.state.filteredOptions.status !== "" &&
                    this.state.choice.status !== null && (
                      <span className="filteredBadge">
                        <span>
                          Status - {this.state.filteredOptions.status}
                        </span>
                        <span onClick={this.applyFilterStatus} className="ms-2">
                          <CommonIcon fileName={"CloseSmallwhite"} />
                        </span>
                      </span>
                    )}
                </div>
                <p className="mb-0 mt-2 countValue">
                  Count: {this.state.normalData.length}
                </p>
              </>
            )}

            <div className="groupcardmobileusers" ref={this.scrollContainerRef}>
              {this.state.normalData.length < 1 ? (
                <div
                  className="card sharpcorner  cursor-pointer px-2 my-2 mt-2 p-2"
                  style={{ width: "94%", minHeight: "100px" }}
                >
                  <div className="card-body">
                    <div
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "-0.1px",
                        bottom: "-0.2px",
                        width: "4px",
                        backgroundColor: " rgb(33, 150, 243)",
                      }}
                    ></div>
                    <div className="row">
                      <div className="col-12  d-flex align-items-center">
                        <div className="row text-center w-100">
                          <div className="col-12">
                            <span
                              className="nofound "
                              style={{ fontWeight: "bold" }}
                            >
                              No user found
                            </span>
                          </div>
                          {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                this.state.normalData.map((element, inde) => {
                  return (
                    <div
                      className="card sharpcorner  cursor-pointer px-2 my-2  pt-1 pb-1"
                      style={{ width: "94%", minHeight: "145px" }}
                      onClick={() =>
                        this.handleEditId(element.id, element.email)
                      }
                    >
                      <div className="card-body pt-0 pb-0">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: " rgb(33, 150, 243)",
                          }}
                        ></div>
                        <div className="row">
                          <div
                            className={`col-12 d-flex align-items-center mb-1 ${
                              this.state.isMobile ? "pt-2" : ""
                            }`}
                          >
                            <div className="row">
                              <div className="col-12">
                                <span
                                  className="reporttext14mobile"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {element.firstName + element.lastName}
                                </span>
                              </div>
                              {/* <div className="col-12"><span className="reporttext12" style={{ fontWeight: "bold" }}>{}</span></div> */}
                            </div>
                          </div>
                          <div className="col-12 d-flex align-items-start">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14mobile">
                                  Email
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.email}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-start">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14mobile">
                                  Last Login
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.lastLoginDate}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-start">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14mobile">
                                  Status
                                </span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.userStatus}
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-6 d-flex align-items-start">
                                <div className="row ">
                                  <div className="col-12"><span className="reporttext14mobile" >Applications</span></div>
                                  <div className="col-12"><span className="reporttext12" >{element.applications}-</span></div>
                                </div>
                              </div> */}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* <ListViewTable scrollRef={this.tableRef} handleScroll={this.handleScroll} columns={this.state.columnHeaders} data={this.state.groupedData} value={this.state.normalData} handleSort={this.handleSort} toggleGroup={this.toggleGroup} groupedName={this.state.groupedColumn} collapsedGroups={this.state.collapsedGroups} sortConfig={this.state.filters} handleChangeId={this.handleEditId} handleDeleteChangeId={this.handleDeleteId} isLoader={this.state.isLoader} /> */}

            {/* New form */}
            <div
              className="offcanvas offcanvas-end  offcanvas-no-animation"
              tabIndex={-1}
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="AddFormuser"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className="height100scroll">
                <div className={`offcanvas-header  pt-3 pb-3 mt-10`}>
                  <span className="headerforminviteusermobile px-3 ps-4">
                    {(this.state.view &&
                      this.state.viewUser &&
                      this.state.editUser) ||
                    this.state.editUser
                      ? this.state.viewUser.firstName
                        ? this.state.viewUser.firstName +
                          " " +
                          this.state.viewUser.lastName
                        : this.state.viewUser.email
                      : "Invite User"}
                  </span>
                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose closeexit"
                    onClick={() => this.closeForm()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>

                <div
                  className="offcanvas-body ps-4  pt-0"
                  style={{ overflow: "hidden" }}
                >
                  <div className="row" style={{ padding: "0rem 1rem" }}>
                    {/* <TextField
                        id='phonenumber'
                        className={`filter_input br-4 ${this.state.view && !this.state.editUser ? "" : "d-none"}`}
                        variant="filled"
                        value={this.state.addUser.phonenumber}
                        onChange={(e) => this.addEditChange(e, "", "phonenumber")}
                        focused
                        style={{ width: "90%" }}
                        inputProps={{
                          pattern: "[0-9]*",
                          inputMode: "numeric"
                        }}
                      /> */}
                    <div
                      className={`${
                        this.state.view === true
                          ? "col-12 pb-3  flex-1"
                          : "col-12 pb-3 flex-1"
                      }`}
                    >
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Email
                        <span
                          className={`isrequired ${
                            this.state.view === true ? "" : "d-none"
                          }`}
                        >
                          *
                        </span>
                      </FormLabel>
                      {!this.state.editUser &&
                      this.state.view === true &&
                      this.state.ssoDetails.length > 0 ? (
                        <Autocomplete
                          fullWidth
                          loading={this.state.isusersLoading}
                          error={this.state.emailError}
                          options={
                            this.state.isusersLoading
                              ? []
                              : this.state.tenantUsers
                          }
                          value={this.state.tenantValue}
                          onChange={this.handletenantChange}
                          getOptionLabel={(option) =>
                            `${
                              option.email ? option.email : option.displayName
                            }`
                          }
                          filterOptions={(options, params) => {
                            const inputValue = params.inputValue.toLowerCase();
                            return options.filter((option) => {
                              const displayName =
                                option.displayName?.toLowerCase() || "";
                              const email = option.email?.toLowerCase() || "";
                              return (
                                displayName.includes(inputValue) ||
                                email.includes(inputValue)
                              );
                            });
                          }}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              key={option.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                              }}
                            >
                              <Avatar
                                sx={{ width: 35, height: 35, marginRight: 2 }}
                              >
                                {option.displayName.charAt(0)}
                              </Avatar>
                              <div>
                                <strong>{option.displayName}</strong>
                                <div>{option.email}</div>
                              </div>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              error={this.state.emailError}
                              className="filter_input12" // or "outlined" if needed
                              InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                // removes underline
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiInputBase-root": {
                              outline: "none",
                              padding: "6px",
                              paddingLeft: "12px",
                              fontSize: "13px",
                            },
                          }}
                        />
                      ) : (
                        <></>
                      )}
                      {/* <FormLabel className={`formlabel-input w-100 ${this.state.view === true ? "" : "d-none"}`} id="first-name-label">{this.state.viewUser.email}</FormLabel> */}
                      {!this.state.editUser &&
                      this.state.view === true &&
                      this.state.ssoDetails.length == 0 ? (
                        <TextField
                          error={this.state.emailError}
                          id="email"
                          className={`filter_input br-4 ${
                            this.state.view === true && !this.state.editUser
                              ? ""
                              : "d-none"
                          }`}
                          // fullWidth label="First Name"
                          variant="filled"
                          value={this.state.addUser.email}
                          onChange={(e) => this.addEditChange(e, "", "email")}
                          focused
                          inputProps={{ maxLength: 255 }}
                          fullWidth
                        />
                      ) : (
                        <></>
                      )}
                      <TextField
                        error={this.state.emailError}
                        id="edit_email"
                        className={`filter_input br-4 ${
                          this.state.editUser === true ? "" : "d-none"
                        }`}
                        inputProps={{ maxLength: 255 }}
                        // fullWidth label="First Name"
                        variant="filled"
                        value={this.state.editUserData.email}
                        onChange={(e) => this.addEditChange(e, "", "email")}
                        focused
                        InputProps={{
                          readOnly: true,
                          disabled: true, // Make the TextField read-only
                        }}
                        fullWidth
                      />
                      {this.state.emailError && (
                        <div className="error-message" style={{ color: "red" }}>
                          {this.state.emailErrorMessage}
                        </div>
                      )}
                    </div>
                    <div
                      className={`${
                        this.state.view === true
                          ? "col-12 pb-3 flex-1"
                          : "col-12 pb-3  flex-1"
                      }`}
                    >
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Phone Number
                      </FormLabel>
                      {/* <FormLabel className={`formlabel-input w-100 ${this.state.view === true ? "" : "d-none"}`} id="first-name-label">{this.state.viewUser.phone}</FormLabel> */}
                      {this.state.view && !this.state.editUser && (
                        <>
                          <div className="w-100 d-flex">
                            <Autocomplete
                              options={this.state.countryData}
                              className="filter_input12"
                              getOptionLabel={(option) =>
                                option.countryCode || ""
                              }
                              value={
                                this.state.countryData.find(
                                  (item) =>
                                    item.countryCode ==
                                    this.state.primaryPhoneCode
                                ) || null
                              }
                              onChange={(e, newValue) => {
                                this.setState({
                                  primaryPhoneCode: newValue?.countryCode
                                    ? newValue.countryCode
                                    : "",
                                });
                              }}
                              // renderOption={(props, option, { selected }) => (
                              //   <li {...props} key={option.id}>
                              //     {option.countryCode}
                              //   </li>
                              // )}
                              renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <Box
                                    key={option.id}
                                    component="li"
                                    sx={{
                                      "& > img": { mr: 1.5, flexShrink: 0 },
                                    }}
                                    {...optionProps}
                                  >
                                    <img
                                      loading="lazy"
                                      width="24"
                                      height="18"
                                      srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                      src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                      alt=""
                                    />
                                    {option.countryCode}
                                  </Box>
                                );
                              }}
                              filterOptions={(options, state) => {
                                const input = state.inputValue
                                  .replace("+", "")
                                  .trim()
                                  .toLowerCase();

                                return options.filter((option) => {
                                  const code =
                                    option.countryCode
                                      ?.replace("+", "")
                                      .toLowerCase() || "";
                                  const name =
                                    option.countryName?.toLowerCase() || "";

                                  // ✅ Match either country code or country name
                                  return (
                                    code.includes(input) || name.includes(input)
                                  );
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  error={this.state.phoneError}
                                  className="filter_input12" // or "outlined" if needed
                                  InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    // removes underline
                                  }}
                                />
                              )}
                              sx={{
                                width: 150,
                                "& .MuiInputBase-root": {
                                  borderRight: "none !important",
                                  outline: "none",
                                  padding: "6px",
                                  paddingLeft: "12px",
                                  fontSize: "13px",
                                },
                              }}
                            />
                            <TextField
                              id="phonenumber"
                              className={`filter_input br-4 ${
                                this.state.view && !this.state.editUser
                                  ? ""
                                  : "d-none"
                              }`}
                              variant="filled"
                              error={this.state.phoneError}
                              value={this.state.addUser.phonenumber}
                              onChange={(e) =>
                                this.addEditChange(e, "", "phonenumber")
                              }
                              focused
                              style={{ width: "90%" }}
                              inputProps={{
                                pattern: "[0-9]*",
                                inputMode: "numeric",
                              }}
                            />
                          </div>
                          {this.state.phoneError && (
                            <span className="errorMessage">
                              {this.state.phoneError}
                            </span>
                          )}
                        </>
                      )}
                      {this.state.editUser === true && (
                        <>
                          <div className="w-100 d-flex">
                            <Autocomplete
                              options={this.state.countryData}
                              className="filter_input12"
                              getOptionLabel={(option) =>
                                option.countryCode || ""
                              }
                              value={
                                this.state.countryData.find(
                                  (item) =>
                                    item.countryCode ==
                                    this.state.primaryPhoneCode
                                ) || null
                              }
                              onChange={(e, newValue) => {
                                this.setState({
                                  primaryPhoneCode: newValue?.countryCode
                                    ? newValue.countryCode
                                    : "",
                                });
                              }}
                              // renderOption={(props, option, { selected }) => (
                              //   <li {...props} key={option.id}>
                              //     {option.countryCode}
                              //   </li>
                              // )}
                              renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <Box
                                    key={option.id}
                                    component="li"
                                    sx={{
                                      "& > img": { mr: 1.5, flexShrink: 0 },
                                    }}
                                    {...optionProps}
                                  >
                                    <img
                                      loading="lazy"
                                      width="24"
                                      height="18"
                                      srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                      src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                      alt=""
                                    />
                                    {option.countryCode}
                                  </Box>
                                );
                              }}
                              filterOptions={(options, state) => {
                                const input = state.inputValue
                                  .replace("+", "")
                                  .trim()
                                  .toLowerCase();

                                return options.filter((option) => {
                                  const code =
                                    option.countryCode
                                      ?.replace("+", "")
                                      .toLowerCase() || "";
                                  const name =
                                    option.countryName?.toLowerCase() || "";

                                  // ✅ Match either country code or country name
                                  return (
                                    code.includes(input) || name.includes(input)
                                  );
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  error={this.state.phoneError}
                                  className="filter_input12" // or "outlined" if needed
                                  InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    // removes underline
                                  }}
                                />
                              )}
                              sx={{
                                width: 150,
                                "& .MuiInputBase-root": {
                                  borderRight: "none !important",
                                  outline: "none",
                                  padding: "6px",
                                  paddingLeft: "12px",
                                  fontSize: "13px",
                                },
                              }}
                            />
                            <TextField
                              error={this.state.phoneError}
                              id="edit_phonenumber"
                              className={`filter_input br-4 ${
                                this.state.editUser === true ? "" : "d-none"
                              }`}
                              // fullWidth label="First Name"
                              variant="filled"
                              value={this.state.editUserData.phonenumber}
                              onChange={(e) =>
                                this.addEditChange(e, "", "phonenumber")
                              }
                              focused
                              style={{ width: "90%" }}
                            />
                          </div>
                          {this.state.phoneError && (
                            <span className="errorMessage">
                              {this.state.phoneError}
                            </span>
                          )}
                        </>
                      )}

                      {/* {this.state.lastNameError && (
                          <div className="error-message" style={{ color: 'red' }}>
                            {this.state.lastNameErrorMessage}
                          </div>
                        )} */}
                    </div>
                    <div
                      className={`${
                        this.state.view === true
                          ? "col-12 pb-3 flex-1"
                          : "col-12 pb-3 flex-1"
                      }`}
                    >
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        First Name
                      </FormLabel>
                      {/* <FormLabel className={`formlabel-input-style w-100 ${this.state.view === true ? "" : "d-none"}`} id="first-name-label">{this.state.viewUser.firstName}</FormLabel> */}
                      <TextField
                        id="first_name"
                        className={`filter_input br-4 ${
                          this.state.view && !this.state.editUser
                            ? ""
                            : "d-none"
                        }`}
                        variant="filled"
                        value={this.state.addUser.firstName}
                        onChange={(e) => this.addEditChange(e, "", "firstName")}
                        focused
                        inputProps={{ maxLength: 255 }}
                        fullWidth
                      />
                      <TextField
                        error={this.state.firstNameError}
                        id="edit_first_name"
                        inputProps={{ maxLength: 255 }}
                        className={`filter_input br-4 ${
                          this.state.editUser === true ? "" : "d-none"
                        }`}
                        //fullWidth label="First Name"
                        variant="filled"
                        value={this.state.editUserData.firstName}
                        onChange={(e) => this.addEditChange(e, "", "firstName")}
                        focused
                        fullWidth
                        // error={true}
                      />
                      {/* {this.state.firstNameError && (
                          <div className="error-message" style={{ color: 'red' }}>
                            {this.state.firstNameErrorMessage}
                          </div>
                        )} */}
                    </div>

                    <div
                      className={`${
                        this.state.view === true
                          ? "col-12 pb-3 flex-1"
                          : "col-12 pb-3  flex-1"
                      }`}
                    >
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Last Name
                      </FormLabel>
                      {/* <FormLabel className={`formlabel-input w-100 ${this.state.view === true ? "" : "d-none"}`} id="first-name-label">{this.state.viewUser.lastName}</FormLabel> */}
                      <TextField
                        // error={this.state.lastNameError}
                        id="last_name"
                        className={`filter_input br-4 ${
                          this.state.view && !this.state.editUser
                            ? ""
                            : "d-none"
                        }`}
                        // fullWidth label="First Name"
                        variant="filled"
                        value={this.state.addUser.lastName}
                        onChange={(e) => this.addEditChange(e, "", "lastName")}
                        focused
                        fullWidth
                      />
                      <TextField
                        error={this.state.lastNameError}
                        id="edit_last_name"
                        className={`filter_input br-4 ${
                          this.state.editUser === true ? "" : "d-none"
                        }`}
                        // fullWidth label="First Name"
                        variant="filled"
                        value={this.state.editUserData.lastName}
                        onChange={(e) => this.addEditChange(e, "", "lastName")}
                        focused
                        fullWidth
                      />
                      {/* {this.state.lastNameError && (
                          <div className="error-message" style={{ color: 'red' }}>
                            {this.state.lastNameErrorMessage}
                          </div>
                        )} */}
                    </div>
                    <div
                      className={`${
                        this.state.view === true
                          ? "col-12 pb-3 flex-1"
                          : "col-12 pb-3  flex-1"
                      }`}
                    >
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Manager<span className={`isrequired`}>*</span>
                      </FormLabel>
                      <Autocomplete
                        fullWidth
                        error={this.state.managerError}
                        options={this.state.ManagerUsers}
                        // value={this.state.managerValue}
                        value={
                          this.state.ManagerUsers.find(
                            (u) => u.id === this.state.addUser.managerId
                          ) || null
                        }
                        onChange={this.handleManagerChangeAdd}
                        getOptionLabel={(option) =>
                          `${option.email ? option.email : option.firstName}`
                        }
                        filterOptions={(options, params) => {
                          const inputValue = params.inputValue.toLowerCase();
                          return options.filter((option) => {
                            const displayName = `${option.firstName ?? ""} ${
                              option.lastName ?? ""
                            }`
                              .trim()
                              .toLowerCase();

                            const email = option.email?.toLowerCase() || "";
                            return (
                              displayName.includes(inputValue) ||
                              email.includes(inputValue)
                            );
                          });
                        }}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            key={option.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            <Avatar
                              sx={{ width: 35, height: 35, marginRight: 2 }}
                            >
                              {option.firstName.charAt(0)}
                            </Avatar>
                            <div>
                              <strong>
                                {option.firstName} {option.lastName}
                              </strong>
                              <div>{option.email}</div>
                            </div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            error={this.state.managerError}
                            helperText={
                              this.state.managerError
                                ? "Please select manager"
                                : ""
                            }
                            className={`filter_input12 ${
                              this.state.view && !this.state.editUser
                                ? ""
                                : "d-none"
                            }`} // or "outlined" if needed
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              // removes underline
                            }}
                          />
                        )}
                        sx={{
                          "& .MuiInputBase-root": {
                            outline: "none",
                            padding: "6px",
                            paddingLeft: "12px",
                            fontSize: "13px",
                          },
                        }}
                      />
                      <Autocomplete
                        fullWidth
                        error={this.state.managerError}
                        options={this.state.ManagerUsers}
                        value={
                          this.state.ManagerUsers.find(
                            (u) => u.id === this.state.editUserData.managerId
                          ) || null
                        }
                        onChange={this.handleManagerChangeEdit}
                        getOptionLabel={(option) =>
                          `${option.email ? option.email : option.firstName}`
                        }
                        filterOptions={(options, params) => {
                          const inputValue = params.inputValue.toLowerCase();
                          return options.filter((option) => {
                            const displayName = `${option.firstName ?? ""} ${
                              option.lastName ?? ""
                            }`
                              .trim()
                              .toLowerCase();

                            const email = option.email?.toLowerCase() || "";
                            return (
                              displayName.includes(inputValue) ||
                              email.includes(inputValue)
                            );
                          });
                        }}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            key={option.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "12px",
                            }}
                          >
                            <Avatar
                              sx={{ width: 35, height: 35, marginRight: 2 }}
                            >
                              {option.firstName.charAt(0)}
                            </Avatar>
                            <div>
                              <strong>
                                {option.firstName} {option.lastName}
                              </strong>
                              <div>{option.email}</div>
                            </div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            error={this.state.managerError}
                            helperText={
                              this.state.managerError
                                ? "Please select manager"
                                : ""
                            }
                            className={`filter_input12 ${
                              this.state.editUser === true ? "" : "d-none"
                            }`} // or "outlined" if needed
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              // removes underline
                            }}
                          />
                        )}
                        sx={{
                          "& .MuiInputBase-root": {
                            outline: "none",
                            padding: "6px",
                            paddingLeft: "12px",
                            fontSize: "13px",
                          },
                        }}
                      />
                    </div>

                    {/* <div className={`col-5 pb-4 flex-1 ${this.state.view === true ? "" : "d-none"}`}>
                        <FormLabel className="formlabel-style w-100" id="first-name-label">Status<span className={`isrequired ${this.state.view === true ? "d-none" : ""}`}>*</span></FormLabel>
                        <FormLabel className={`formlabel-input w-100 ${this.state.view === true ? "" : "d-none"} ${this.state.viewUser.isActive === true ? 'status_green' : 'status_red'}`} style={{ color: this.state.viewUser.isActive === true ? 'green' : 'red' }} id="first-name-label">{this.state.viewUser.isActive === true ? "Active" : "InActive"}</FormLabel>

                      </div> */}
                    <div
                      className={`col-12 pb-3 flex-1 ${
                        this.state.editUser === true ? "" : "d-none"
                      }`}
                    >
                      <FormLabel
                        className="formlabel-style w-100"
                        id="first-name-label"
                      >
                        Status
                        <span
                          className={`isrequired ${
                            this.state.view === true ? "d-none" : ""
                          }`}
                        >
                          *
                        </span>
                      </FormLabel>
                      <div>
                        <Switch
                          // classes={{
                          //   root: classes.root,
                          //   switchBase: classes.switchBase,
                          //   thumb: classes.thumb,
                          //   track: classes.track,
                          //   checked: classes.checked,
                          // }}
                          sx={{
                            width: "60px",
                            height: "28px",
                            padding: "0px",

                            // Switch Base
                            "& .MuiSwitch-switchBase": {
                              color: "#818181",
                              padding: "1px",

                              "&.Mui-checked": {
                                "& + .MuiSwitch-track": {
                                  backgroundColor:
                                    "rgba(34, 110, 183, 1) !important",

                                  "&:after": {
                                    display: "block",
                                  },
                                  "&:before": {
                                    display: "none",
                                  },
                                },
                              },
                            },

                            // Thumb
                            "& .MuiSwitch-thumb": {
                              width: "20px",
                              height: "20px",
                              margin: "1px",
                              marginLeft: "-8px",
                              marginTop: "3px",
                              backgroundColor: "white !important",
                              color: "white !important",
                            },

                            // Track
                            "& .MuiSwitch-track": {
                              borderRadius: "20px !important",
                              backgroundColor: "#818181 !important",
                              opacity: "1 !important",
                              position: "relative",

                              "&:after, &:before": {
                                color: "white !important",
                                fontSize: "8px",
                                position: "absolute",
                                top: "6px",
                              },

                              "&:after": {
                                content: '"Active"',
                                left: "4px",
                                top: "8px",
                                display: "none",
                              },
                              "&:before": {
                                content: '"Inactive"',
                                right: "3px",
                                top: "8px",
                              },
                            },

                            // Checked State Thumb Transform
                            "& .Mui-checked .MuiSwitch-thumb": {
                              transform: "translateX(14px) !important",
                              color: "rgba(34, 110, 183, 1) !important",
                            },
                          }}
                          checked={this.state.editUserData.isActive}
                          onChange={(e) =>
                            this.addEditChange(e, "", "isActive")
                          }
                          name="checkedA"
                          inputProps={{ "aria-label": "secondary checkbox" }}
                        />
                      </div>
                    </div>
                    {/* <hr className={`${this.state.editUser == false   ? "d-none" : ""}`}/> */}
                  </div>
                  <p class="ml-12" />
                  <div className="row" style={{ padding: "0rem 1rem" }}>
                    <div className="col-12 pb-3">
                      <button
                        className={`btn-fun btn-action btn-filter-action ${
                          this.state.view && this.state.editUser === true
                            ? "d-none"
                            : ""
                        }`}
                        variant="primary"
                        onClick={() => this.handleAdd()}
                      >
                        Invite User
                      </button>
                      <button
                        className={`btn-fun btn-action btn-filter-action ${
                          this.state.editUser === true ? "" : "d-none"
                        }`}
                        variant="primary"
                        onClick={() => this.handleUpdate()}
                      >
                        Update
                      </button>
                      <Button
                        data-bs-dismiss="offcanvas"
                        className={`btn-cancel btn-filter-action ${
                          this.state.view &&
                          this.state.viewUser &&
                          this.state.editUser === true
                            ? "d-none"
                            : ""
                        }`}
                        variant="outlined"
                        onClick={() => this.closeForm()}
                      >
                        Cancel
                      </Button>
                      <br />
                      {this.state.editUserData.isAdmin !== true && (
                        <label
                          className={`removeuser text-danger ms-0  ${
                            this.state.editUser === true ? "" : "d-none"
                          }`}
                          onClick={() => this.popup()}
                        >
                          Remove from organization
                        </label>
                      )}
                    </div>
                  </div>
                  {/* <hr className={`${this.state.editUser == false   ? "d-none" : ""}`}/> */}
                  <div>
                    <div className={`col-12 `}>
                      {/* <label className={`removeuser text-danger ${this.state.editUser === true ? "" : "d-none"}`}  onClick={()=>this.popup()}>Remove from organization</label> */}
                      {/* <Button data-bs-dismiss="offcanvas" className={`${this.state.view != true ? "d-none" : ""}`} variant="danger" onClick={() => this.closeForm()}>Remove User</Button> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Edit Job */}

            {/* filter offcanvas */}
            <div
              className="offcanvas offcanvas-end"
              tabIndex={-1}
              data-bs-scroll="false"
              data-bs-backdrop="false"
              id="FilterScreen"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                <h6
                  id="offcanvasRightLabel"
                  className="modal-title head-span"
                  style={{ fontWeight: "600" }}
                >
                  Filter
                </h6>
                <button
                  className="offcavasclose"
                  onClick={() => this.closeWebFilter()}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="offcanvas-body px-4 pt-0">
                <div className="row">
                  <div
                    className="row"
                    style={{
                      padding: "1rem",
                      paddingTop: "0",
                      paddingRight: "0px",
                    }}
                  >
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpTitle"
                        className="filter_input"
                        fullWidth
                        label="Name"
                        variant="filled"
                        value={this.state.choice.name}
                        onChange={(e) => this.lookupChange(e, "", "name")}
                        focused
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      <TextField
                        id="jobOpOpenPositions"
                        fullWidth
                        label="Email (User Name)"
                        className="filter_input"
                        variant="filled"
                        value={this.state.choice.email}
                        onChange={(e) => this.lookupChange(e, "", "email")}
                        focused
                        disablePortal
                      />
                    </div>
                    <div className={`col-12 mt-2 pe-2`}>
                      {/* <Autocomplete
                            focused
                            id="roleId"
                            variant="filled"
                            disablePortal
                            value={this.state.choice.isActive !== null ? { id: this.state.choice.isActive ? "1" : "2", status: this.state.choice.isActive ? "Active" : "InActive" } : null}
                            options={[{ id: "1", status: "Active" }, { id: "2", status: "InActive" }]}
                            getOptionLabel={(option) => option.status || ""}
                            onChange={(e, selectedValue) => this.lookupChange(e, selectedValue, "isActive")}
                            renderOption={(props, option, { selected }) => (
                              <li {...props} key={option.id}>
                                {option.status}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField {...params} variant="filled" className='filter_input' focused label="Status" />
                            )}
                          /> */}
                      <Autocomplete
                        focused
                        id="roleId"
                        variant="filled"
                        disablePortal
                        getOptionLabel={(option) => option.status}
                        value={
                          this.state.choice.status
                            ? { id: "", status: this.state.choice.status }
                            : null
                        }
                        options={[
                          { id: "1", status: "Active" },
                          { id: "2", status: "Inactive" },
                          { id: "3", status: "Pending" },
                        ]}
                        onChange={(e, selectedValue) =>
                          this.lookupChange(e, selectedValue, "isActive")
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.id}>
                            {option.status}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="filled"
                            className="filter_input"
                            focused
                            label="Status"
                          />
                        )}
                      />
                    </div>
                    <div className={`col-12 mt-2 lastlogindate pe-2`}>
                      <TextField
                        type="date"
                        id="jobOpOpenPositions"
                        fullWidth
                        label="Last Login"
                        className="filter_input"
                        variant="filled"
                        value={this.state.choice.lastLoginDate || ""}
                        onChange={(e) =>
                          this.lookupChange(e, "", "lastLoginDate")
                        }
                        focused
                        disablePortal
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row pe-4">
                <div className="col-12 align_justify_end pb-20 ">
                  <Button
                    className="btn-clear mr-10"
                    variant="outlined"
                    onClick={() => this.clearFilter()}
                  >
                    Reset
                  </Button>
                  <button
                    className="btn-apply"
                    variant="primary"
                    onClick={() => this.applyFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>

            {/* off canvas modal */}
            <div
              className={`modal modal-style viewbar-overlay  ${
                this.state.opendailog ? "show" : ""
              }`}
              id="Additionform"
              tabindex="1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              style={{
                display: this.state.opendailog ? "block" : "none",
                zindex: "1050",
              }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow-lg bg-white rounded">
                  <div className="modal-body text-center">
                    <CommonIcon fileName={"removeuser"} />
                    <br />
                    <span>
                      {
                        "Are you sure you want to remove this user from the organization"
                      }
                    </span>
                  </div>
                  <div className="modal-footer justify-content-center">
                    <Button
                      className="btn-no px-4"
                      variant="primary"
                      onClick={() => this.noAction()}
                    >
                      No
                    </Button>{" "}
                    <Button
                      className="btn-action px-4"
                      variant="primary"
                      onClick={() => this.yesAction()}
                    >
                      Yes
                    </Button>{" "}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <>
              <div className="content-header">
                <Backdrop
                  className="spinner-backdrop"
                  open={isloading || this.props.addUserIsLoader}
                >
                  <CircularProgress color="primary" />
                </Backdrop>
                <div className="w-100" style={{ paddingRight: "2rem" }}>
                  <div className="row tapbar">
                    <div className="col-5 ">
                      <span className="headerform1">Users</span>
                    </div>
                    <div className="col-lg-7 col-sm-7 col-12 col-md-7 justify-right pt-2 ">
                      <div className="btn-container">
                        <button
                          className="  btn-fun btn-new fs-7 me-0 d-flex align-items-center"
                          type="button"
                          onClick={() => {
                            this.newFormShow(true);
                          }}
                        >
                          <CommonIcon fileName={"AddPlus1"} />
                          Invite User
                        </button>{" "}
                        {/* <button className='me-0 btn-fun ps-3 pe-3' type="button" onClick={this.toggleWebFilter}><CommonIcon fileName={'Filter'} /> </button>{' '} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <ToastContainer /> */}
              {/* Table */}
              {/* <ListViewTable scrollRef={this.tableRef} handleScroll={this.handleScroll} columns={this.state.columnHeaders} data={this.state.groupedData} value={this.state.normalData} handleSort={this.handleSort} toggleGroup={this.toggleGroup} groupedName={this.state.groupedColumn} collapsedGroups={this.state.collapsedGroups} sortConfig={this.state.filters} handleChangeId={this.handleEditId} handleDeleteChangeId={this.handleDeleteId} isLoader={this.state.isLoader} /> */}
              <div
                className="pt-2 usersTableHeight"
                style={{ marginRight: "2rem" }}
              >
                <CustomListView
                  columns={this.state.columns}
                  listData={this.state.normalData}
                  handleDataFetch={this.handleDataFetch}
                  totalCount={this.state.totalCount}
                  isLoading={this.state.tableLoader}
                />
              </div>
              {/* Add & Edit User */}
              <div
                className="offcanvas offcanvas-end offcanvas-no-animation"
                tabIndex={-1}
                data-bs-scroll="false"
                data-bs-backdrop="false"
                id="AddFormuser"
                aria-labelledby="offcanvasScrollingLabel"
                style={{ zIndex: "1500" }}
              >
                <div className="height100scroll">
                  <div className={`offcanvas-header  pt-3 pb-3 mt-10`}>
                    <span className="headerforminviteuser px-3 ps-3">
                      {(this.state.view &&
                        this.state.viewUser &&
                        this.state.editUser) ||
                      this.state.editUser
                        ? this.state.viewUser.firstName +
                          " " +
                          this.state.viewUser.lastName
                        : "Invite User"}
                    </span>
                    <button
                      data-bs-dismiss="offcanvas"
                      className="offcavasclose closeexit pe-0"
                      onClick={() => this.closeForm()}
                    >
                      <CommonIcon fileName={"Close"} />
                    </button>
                  </div>

                  <div
                    className="offcanvas-body ps-3  pt-0"
                    style={{ overflow: "hidden" }}
                  >
                    <div className="row" style={{ padding: "0rem 1rem" }}>
                      <div
                        className={`${
                          this.state.view === true
                            ? "col-12 flex-1 pb-3"
                            : "col-12  pb-3 flex-1"
                        }`}
                      >
                        <FormLabel
                          className="formlabel-style w-100"
                          id="first-name-label"
                        >
                          Email (User Name)
                          <span
                            className={`isrequired ${
                              this.state.view === true ? "" : "d-none"
                            }`}
                          >
                            *
                          </span>
                        </FormLabel>
                        {!this.state.editUser &&
                        this.state.view === true &&
                        this.state.ssoDetails.length > 0 ? (
                          <Autocomplete
                            fullWidth
                            loading={this.state.isusersLoading}
                            error={this.state.emailError}
                            options={
                              this.state.isusersLoading
                                ? []
                                : this.state.tenantUsers
                            }
                            value={this.state.tenantValue}
                            onChange={this.handletenantChange}
                            getOptionLabel={(option) =>
                              `${
                                option.email ? option.email : option.displayName
                              }`
                            }
                            filterOptions={(options, params) => {
                              const inputValue =
                                params.inputValue.toLowerCase();
                              return options.filter((option) => {
                                const displayName =
                                  option.displayName?.toLowerCase() || "";
                                const email = option.email?.toLowerCase() || "";
                                return (
                                  displayName.includes(inputValue) ||
                                  email.includes(inputValue)
                                );
                              });
                            }}
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                key={option.id}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "12px",
                                }}
                              >
                                <Avatar
                                  sx={{ width: 35, height: 35, marginRight: 2 }}
                                >
                                  {option.displayName.charAt(0)}
                                </Avatar>
                                <div>
                                  <strong>{option.displayName}</strong>
                                  <div>{option.email}</div>
                                </div>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="filled"
                                error={this.state.emailError}
                                className="filter_input12" // or "outlined" if needed
                                InputProps={{
                                  ...params.InputProps,
                                  disableUnderline: true,
                                  // removes underline
                                }}
                              />
                            )}
                            sx={{
                              "& .MuiInputBase-root": {
                                outline: "none",
                                padding: "6px",
                                paddingLeft: "12px",
                                fontSize: "13px",
                              },
                            }}
                          />
                        ) : (
                          <></>
                        )}
                        {!this.state.editUser &&
                        this.state.view === true &&
                        this.state.ssoDetails.length == 0 ? (
                          <TextField
                            error={this.state.emailError}
                            id="email"
                            className={`filter_input br-4 ${
                              this.state.view === true && !this.state.editUser
                                ? ""
                                : "d-none"
                            }`}
                            inputProps={{ maxLength: 255 }}
                            variant="filled"
                            value={this.state.addUser.email}
                            onChange={(e) => this.addEditChange(e, "", "email")}
                            focused
                            fullWidth
                          />
                        ) : (
                          <></>
                        )}
                        <TextField
                          error={this.state.emailError}
                          id="edit_email"
                          className={`filter_input br-4 ${
                            this.state.editUser === true ? "" : "d-none"
                          }`}
                          variant="filled"
                          value={this.state.editUserData.email}
                          onChange={(e) => this.addEditChange(e, "", "email")}
                          focused
                          inputProps={{ maxLength: 255 }}
                          InputProps={{
                            readOnly: true,
                            disabled: true,
                          }}
                          fullWidth
                        />
                        {this.state.emailError && (
                          <div
                            className="error-message"
                            style={{ color: "red" }}
                          >
                            {this.state.emailErrorMessage}
                          </div>
                        )}
                      </div>
                      <div
                        className={`${
                          this.state.view === true
                            ? "col-12 pb-3 flex-1"
                            : "col-12 pb-3  flex-1"
                        }`}
                      >
                        <FormLabel
                          className="formlabel-style w-100"
                          id="first-name-label"
                        >
                          Phone Number
                        </FormLabel>
                        {this.state.view && !this.state.editUser && (
                          <>
                            <div className="w-100 d-flex">
                              <Autocomplete
                                className="filter_input12"
                                options={this.state.countryData}
                                getOptionLabel={(option) =>
                                  option.countryCode || ""
                                }
                                value={
                                  this.state.countryData.find(
                                    (item) =>
                                      item.countryCode ==
                                      this.state.primaryPhoneCode
                                  ) || null
                                }
                                onChange={(e, newValue) => {
                                  this.setState({
                                    primaryPhoneCode: newValue?.countryCode
                                      ? newValue.countryCode
                                      : "",
                                  });
                                }}
                                // renderOption={(props, option, { selected }) => (
                                //   <li {...props} key={option.id}>
                                //     {option.countryCode}
                                //   </li>
                                // )}
                                renderOption={(props, option) => {
                                  const { key, ...optionProps } = props;
                                  return (
                                    <Box
                                      key={option.id}
                                      component="li"
                                      sx={{
                                        "& > img": { mr: 1.5, flexShrink: 0 },
                                      }}
                                      {...optionProps}
                                    >
                                      <img
                                        loading="lazy"
                                        width="24"
                                        height="18"
                                        srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                        src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                        alt=""
                                      />
                                      {option.countryCode}
                                    </Box>
                                  );
                                }}
                                filterOptions={(options, state) => {
                                  const input = state.inputValue
                                    .replace("+", "")
                                    .trim()
                                    .toLowerCase();

                                  return options.filter((option) => {
                                    const code =
                                      option.countryCode
                                        ?.replace("+", "")
                                        .toLowerCase() || "";
                                    const name =
                                      option.countryName?.toLowerCase() || "";

                                    // ✅ Match either country code or country name
                                    return (
                                      code.includes(input) ||
                                      name.includes(input)
                                    );
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="filled"
                                    error={this.state.phoneError}
                                    className="filter_input12" // or "outlined" if needed
                                    InputProps={{
                                      ...params.InputProps,
                                      disableUnderline: true,
                                      // removes underline
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 150,
                                  "& .MuiInputBase-root": {
                                    borderRight: "none !important",
                                    outline: "none",
                                    padding: "6px",
                                    paddingLeft: "12px",
                                    fontSize: "13px",
                                  },
                                }}
                              />
                              <TextField
                                id="phonenumber"
                                className={`filter_input br-4 ${
                                  this.state.view && !this.state.editUser
                                    ? ""
                                    : "d-none"
                                }`}
                                variant="filled"
                                value={this.state.addUser.phonenumber}
                                onChange={(e) =>
                                  this.addEditChange(e, "", "phonenumber")
                                }
                                focused
                                error={this.state.phoneError}
                                style={{ width: "90%" }}
                                inputProps={{
                                  pattern: "[0-9]*",
                                  inputMode: "numeric",
                                }}
                              />
                            </div>
                            {this.state.phoneError && (
                              <span className="errorMessage">
                                {this.state.phoneError}
                              </span>
                            )}
                          </>
                        )}
                        {this.state.editUser === true && (
                          <>
                            <div className="w-100 d-flex">
                              <Autocomplete
                                className="filter_input12"
                                options={this.state.countryData}
                                getOptionLabel={(option) =>
                                  option.countryCode || ""
                                }
                                value={
                                  this.state.countryData.find(
                                    (item) =>
                                      item.countryCode ==
                                      this.state.primaryPhoneCode
                                  ) || null
                                }
                                onChange={(e, newValue) => {
                                  this.setState({
                                    primaryPhoneCode: newValue?.countryCode
                                      ? newValue.countryCode
                                      : "",
                                  });
                                }}
                                // renderOption={(props, option, { selected }) => (
                                //   <li {...props} key={option.id}>
                                //     {option.countryCode}
                                //   </li>
                                // )}
                                renderOption={(props, option) => {
                                  const { key, ...optionProps } = props;
                                  return (
                                    <Box
                                      key={option.id}
                                      component="li"
                                      sx={{
                                        "& > img": { mr: 1.5, flexShrink: 0 },
                                      }}
                                      {...optionProps}
                                    >
                                      <img
                                        loading="lazy"
                                        width="24"
                                        height="18"
                                        srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                        src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                        alt=""
                                      />
                                      {option.countryCode}
                                    </Box>
                                  );
                                }}
                                filterOptions={(options, state) => {
                                  const input = state.inputValue
                                    .replace("+", "")
                                    .trim()
                                    .toLowerCase();

                                  return options.filter((option) => {
                                    const code =
                                      option.countryCode
                                        ?.replace("+", "")
                                        .toLowerCase() || "";
                                    const name =
                                      option.countryName?.toLowerCase() || "";

                                    // ✅ Match either country code or country name
                                    return (
                                      code.includes(input) ||
                                      name.includes(input)
                                    );
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="filled"
                                    error={this.state.phoneError}
                                    className="filter_input12" // or "outlined" if needed
                                    InputProps={{
                                      ...params.InputProps,
                                      disableUnderline: true,
                                      // removes underline
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 150,
                                  "& .MuiInputBase-root": {
                                    borderRight: "none !important",
                                    outline: "none",
                                    padding: "6px",
                                    paddingLeft: "12px",
                                    fontSize: "13px",
                                  },
                                }}
                              />
                              <TextField
                                error={this.state.phoneError}
                                id="edit_phonenumber"
                                className={`filter_input br-4 ${
                                  this.state.editUser === true ? "" : "d-none"
                                }`}
                                variant="filled"
                                value={this.state.editUserData.phonenumber}
                                onChange={(e) =>
                                  this.addEditChange(e, "", "phonenumber")
                                }
                                focused
                                style={{ width: "90%" }}
                              />
                            </div>
                            {this.state.phoneError && (
                              <span className="errorMessage">
                                {this.state.phoneError}
                              </span>
                            )}
                          </>
                        )}
                      </div>
                      <div
                        className={`${
                          this.state.view === true
                            ? "col-12 pb-3 flex-1"
                            : "col-12 pb-3 flex-1"
                        }`}
                      >
                        <FormLabel
                          className="formlabel-style w-100"
                          id="first-name-label"
                        >
                          First Name
                        </FormLabel>
                        <TextField
                          id="first_name"
                          className={`filter_input br-4 ${
                            this.state.view && !this.state.editUser
                              ? ""
                              : "d-none"
                          }`}
                          variant="filled"
                          inputProps={{ maxLength: 255 }}
                          value={this.state.addUser.firstName}
                          onChange={(e) =>
                            this.addEditChange(e, "", "firstName")
                          }
                          focused
                          fullWidth
                        />
                        <TextField
                          error={this.state.firstNameError}
                          id="edit_first_name"
                          className={`filter_input br-4 ${
                            this.state.editUser === true ? "" : "d-none"
                          }`}
                          variant="filled"
                          inputProps={{ maxLength: 255 }}
                          value={this.state.editUserData.firstName}
                          onChange={(e) =>
                            this.addEditChange(e, "", "firstName")
                          }
                          focused
                          fullWidth
                        />
                      </div>

                      <div
                        className={`${
                          this.state.view === true
                            ? "col-12 pb-3 flex-1"
                            : "col-12 pb-3  flex-1"
                        }`}
                      >
                        <FormLabel
                          className="formlabel-style w-100"
                          id="first-name-label"
                        >
                          Last Name
                        </FormLabel>
                        <TextField
                          id="last_name"
                          className={`filter_input br-4 ${
                            this.state.view && !this.state.editUser
                              ? ""
                              : "d-none"
                          }`}
                          variant="filled"
                          inputProps={{ maxLength: 255 }}
                          value={this.state.addUser.lastName}
                          onChange={(e) =>
                            this.addEditChange(e, "", "lastName")
                          }
                          focused
                          fullWidth
                        />
                        <TextField
                          error={this.state.lastNameError}
                          inputProps={{ maxLength: 255 }}
                          id="edit_last_name"
                          className={`filter_input br-4 ${
                            this.state.editUser === true ? "" : "d-none"
                          }`}
                          variant="filled"
                          value={this.state.editUserData.lastName}
                          onChange={(e) =>
                            this.addEditChange(e, "", "lastName")
                          }
                          focused
                          fullWidth
                        />
                      </div>
                      <div
                        className={`${
                          this.state.view === true
                            ? "col-12 pb-3 flex-1"
                            : "col-12 pb-3  flex-1"
                        }`}
                      >
                        <FormLabel
                          className="formlabel-style w-100"
                          id="first-name-label"
                        >
                          Manager<span className={`isrequired`}>*</span>
                        </FormLabel>
                        <Autocomplete
                          fullWidth
                          error={this.state.managerError}
                          options={this.state.ManagerUsers}
                          // value={this.state.managerValue}
                          value={
                            this.state.ManagerUsers.find(
                              (u) => u.id === this.state.addUser.managerId
                            ) || null
                          }
                          onChange={this.handleManagerChangeAdd}
                          getOptionLabel={(option) =>
                            `${option.email ? option.email : option.firstName}`
                          }
                          filterOptions={(options, params) => {
                            const inputValue = params.inputValue.toLowerCase();
                            return options.filter((option) => {
                              const displayName = `${option.firstName ?? ""} ${
                                option.lastName ?? ""
                              }`
                                .trim()
                                .toLowerCase();

                              const email = option.email?.toLowerCase() || "";
                              return (
                                displayName.includes(inputValue) ||
                                email.includes(inputValue)
                              );
                            });
                          }}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              key={option.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                              }}
                            >
                              <Avatar
                                sx={{ width: 35, height: 35, marginRight: 2 }}
                              >
                                {option.firstName.charAt(0)}
                              </Avatar>
                              <div>
                                <strong>
                                  {option.firstName} {option.lastName}
                                </strong>
                                <div>{option.email}</div>
                              </div>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              error={this.state.managerError}
                              helperText={
                                this.state.managerError
                                  ? "Please select manager"
                                  : ""
                              }
                              className={`filter_input12 ${
                                this.state.view && !this.state.editUser
                                  ? ""
                                  : "d-none"
                              }`} // or "outlined" if needed
                              InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                // removes underline
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiInputBase-root": {
                              outline: "none",
                              padding: "6px",
                              paddingLeft: "12px",
                              fontSize: "13px",
                            },
                          }}
                        />
                        <Autocomplete
                          fullWidth
                          error={this.state.managerError}
                          options={this.state.ManagerUsers}
                          value={
                            this.state.ManagerUsers.find(
                              (u) => u.id === this.state.editUserData.managerId
                            ) || null
                          }
                          onChange={this.handleManagerChangeEdit}
                          getOptionLabel={(option) =>
                            `${option.email ? option.email : option.firstName}`
                          }
                          filterOptions={(options, params) => {
                            const inputValue = params.inputValue.toLowerCase();
                            return options.filter((option) => {
                              const displayName = `${option.firstName ?? ""} ${
                                option.lastName ?? ""
                              }`
                                .trim()
                                .toLowerCase();

                              const email = option.email?.toLowerCase() || "";
                              return (
                                displayName.includes(inputValue) ||
                                email.includes(inputValue)
                              );
                            });
                          }}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              key={option.id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                              }}
                            >
                              <Avatar
                                sx={{ width: 35, height: 35, marginRight: 2 }}
                              >
                                {option.firstName.charAt(0)}
                              </Avatar>
                              <div>
                                <strong>
                                  {option.firstName} {option.lastName}
                                </strong>
                                <div>{option.email}</div>
                              </div>
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              error={this.state.managerError}
                              helperText={
                                this.state.managerError
                                  ? "Please select manager"
                                  : ""
                              }
                              className={`filter_input12 ${
                                this.state.editUser === true ? "" : "d-none"
                              }`} // or "outlined" if needed
                              InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                // removes underline
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiInputBase-root": {
                              outline: "none",
                              padding: "6px",
                              paddingLeft: "12px",
                              fontSize: "13px",
                            },
                          }}
                        />
                      </div>
                      <div
                        className={`col-6 pb-3 flex-1 ${
                          this.state.editUser === true ? "" : "d-none"
                        }`}
                      >
                        <FormLabel
                          className="formlabel-style w-100"
                          id="first-name-label"
                        >
                          Status
                          <span
                            className={`isrequired ${
                              this.state.view === true ? "d-none" : ""
                            }`}
                          >
                            *
                          </span>
                        </FormLabel>
                        {document
                          .getElementById("AddFormuser")
                          ?.classList.contains("show") && (
                          <div>
                            <Switch
                              // classes={{
                              //   root: classes.root,
                              //   switchBase: classes.switchBase,
                              //   thumb: classes.thumb,
                              //   track: classes.track,
                              //   checked: classes.checked,
                              // }}
                              sx={{
                                width: "60px",
                                height: "28px",
                                padding: "0px",

                                // Switch Base
                                "& .MuiSwitch-switchBase": {
                                  color: "#818181",
                                  padding: "1px",

                                  "&.Mui-checked": {
                                    "& + .MuiSwitch-track": {
                                      backgroundColor:
                                        "rgba(34, 110, 183, 1) !important",

                                      "&:after": {
                                        display: "block",
                                      },
                                      "&:before": {
                                        display: "none",
                                      },
                                    },
                                  },
                                },

                                // Thumb
                                "& .MuiSwitch-thumb": {
                                  width: "20px",
                                  height: "20px",
                                  margin: "1px",
                                  marginLeft: "2px",
                                  marginTop: "3px",
                                  backgroundColor: "white !important",
                                  color: "white !important",
                                },

                                // Track
                                "& .MuiSwitch-track": {
                                  borderRadius: "20px !important",
                                  backgroundColor: "#818181 !important",
                                  opacity: "1 !important",
                                  position: "relative",

                                  "&:after, &:before": {
                                    color: "white !important",
                                    fontSize: "8px",
                                    position: "absolute",
                                    top: "6px",
                                  },

                                  "&:after": {
                                    content: '"Active"',
                                    left: "4px",
                                    top: "8px",
                                    display: "none",
                                  },
                                  "&:before": {
                                    content: '"Inactive"',
                                    right: "3px",
                                    top: "8px",
                                  },
                                },

                                // Checked State Thumb Transform
                                "& .Mui-checked .MuiSwitch-thumb": {
                                  transform: "translateX(14px) !important",
                                  color: "rgba(34, 110, 183, 1) !important",
                                },
                              }}
                              checked={this.state.editUserData.isActive}
                              onChange={(e) =>
                                this.addEditChange(e, "", "isActive")
                              }
                              name="checkedA"
                              inputProps={{
                                "aria-label": "secondary checkbox",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <p class="ml-12" />
                    <div className="row" style={{ padding: "0rem 1rem" }}>
                      <div className="col-12 pb-3">
                        <button
                          className={`btn-fun btn-action btn-filter-action ${
                            this.state.view && this.state.editUser === true
                              ? "d-none"
                              : ""
                          }`}
                          variant="primary"
                          onClick={() => this.handleAdd()}
                        >
                          Invite User
                        </button>
                        <button
                          className={`btn-fun btn-action btn-filter-action ${
                            this.state.editUser === true ? "" : "d-none"
                          }`}
                          variant="primary"
                          onClick={() => this.handleUpdate()}
                        >
                          Update
                        </button>
                        <Button
                          data-bs-dismiss="offcanvas"
                          className={`btn-cancel btn-filter-action ${
                            this.state.view &&
                            this.state.viewUser &&
                            this.state.editUser === true
                              ? "d-none"
                              : ""
                          }`}
                          variant="outlined"
                          onClick={() => this.closeForm()}
                        >
                          Cancel
                        </Button>
                        {this.state.editUserData.isAdmin !== true && (
                          <label
                            className={`removeuser text-danger float-end  ${
                              this.state.editUser === true ? "" : "d-none"
                            }`}
                            style={{ marginTop: "6px" }}
                            onClick={() => this.popup()}
                          >
                            Remove from organization
                          </label>
                        )}
                      </div>
                    </div>
                    <div>
                      <div className={`col-12 `}></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* filter offcanvas */}
              <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                data-bs-scroll="false"
                data-bs-backdrop="false"
                id="FilterScreen"
                aria-labelledby="offcanvasScrollingLabel"
              >
                <div className={`offcanvas-header px-4 pt-4 pb-3 mt-10`}>
                  <h6
                    id="offcanvasRightLabel"
                    className="modal-title head-span"
                    style={{ fontWeight: "600" }}
                  >
                    Filter
                  </h6>
                  <button
                    className="offcavasclose"
                    onClick={() => this.closeWebFilter()}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>

                <div className="offcanvas-body px-4 pt-0">
                  <div className="row">
                    <div
                      className="row"
                      style={{ padding: "1rem", paddingTop: "0" }}
                    >
                      <div className={`col-12 mt-2`}>
                        <TextField
                          id="jobOpTitle"
                          className="filter_input"
                          fullWidth
                          label="Name"
                          variant="filled"
                          value={this.state.choice.name}
                          onChange={(e) => this.lookupChange(e, "", "name")}
                          focused
                        />
                      </div>
                      <div className={`col-12 mt-2`}>
                        <TextField
                          id="jobOpOpenPositions"
                          fullWidth
                          label="Email (User Name)"
                          className="filter_input"
                          variant="filled"
                          value={this.state.choice.email}
                          onChange={(e) => this.lookupChange(e, "", "email")}
                          focused
                          disablePortal
                        />
                      </div>
                      <div className={`col-12 mt-2`}>
                        <Autocomplete
                          focused
                          id="roleId"
                          variant="filled"
                          disablePortal
                          getOptionLabel={(option) => option.status}
                          value={
                            this.state.choice.status
                              ? { id: "", status: this.state.choice.status }
                              : null
                          }
                          options={[
                            { id: "1", status: "Active" },
                            { id: "2", status: "Inactive" },
                            { id: "3", status: "Pending" },
                          ]}
                          onChange={(e, selectedValue) =>
                            this.lookupChange(e, selectedValue, "isActive")
                          }
                          renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.id}>
                              {option.status}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="filled"
                              className="filter_input"
                              focused
                              label="Status"
                            />
                          )}
                        />
                      </div>
                      <div className={`col-12 mt-2 lastlogindate`}>
                        <TextField
                          type="date"
                          id="jobOpOpenPositions"
                          fullWidth
                          label="Last Login"
                          className="filter_input"
                          variant="filled"
                          value={this.state.choice.lastLoginDate || ""}
                          onChange={(e) =>
                            this.lookupChange(e, "", "lastLoginDate")
                          }
                          focused
                          disablePortal
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 align_justify_end pb-20 pr-54">
                    <Button
                      className="btn-clear mr-10"
                      variant="outlined"
                      onClick={() => this.clearFilter()}
                    >
                      Reset
                    </Button>
                    <button
                      className="btn-apply"
                      variant="primary"
                      onClick={() => this.applyFilter()}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
              {/* {console.log(this.state.opendailog, "op")} */}
              <div
                className={`modal modal-styleuser viewbar-overlay  ${
                  this.state.opendailog ? "show" : ""
                }`}
                id="Additionform"
                tabindex="1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{
                  display: this.state.opendailog ? "block" : "none",
                  zindex: "1050",
                }}
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content shadow-lg bg-white rounded">
                    <div className="modal-body text-center">
                      <CommonIcon fileName={"removeuser"} />
                      <br />
                      <span>
                        {
                          "Are you sure you want to remove this user from the organization"
                        }
                      </span>
                    </div>
                    <div className="modal-footer justify-content-center">
                      <Button
                        className="btn-no px-4"
                        variant="primary"
                        onClick={() => this.noAction()}
                      >
                        No
                      </Button>{" "}
                      <Button
                        className="btn-action px-4"
                        variant="primary"
                        onClick={() => this.yesAction()}
                      >
                        Yes
                      </Button>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </>
          </>
        )}
      </>
    ) : (
      ""
    );
  }
}

// function mapDispatchToProps(dispatch) {
//   return {dispatch};
// }

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    // sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};

function mapStateToProps(state) {
  return {
    getUser: state.userReducer.getUser,
    getParticularUser: state.userReducer.getParticularUser,
    addUser: state.userReducer.addUser,
    isLoading: state.commonReducer.isLoading,
    addUserIsLoader: state.commonReducer.addUserIsLoader,
    isApiSuccess: state.userReducer.isApiSuccess,
    updateUser: state.userReducer.updateUser,
    deleteUser: state.userReducer.deleteUser,
    BG_LOADER: state.userReducer.BG_LOADER,
    menuToggle: state.SideBarReducer.menuToggle,
  };
}

export default withStyles(useStyles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Users))
);
